{
  "levels": [
    {
      "id": 1,
      "className": "Levels.Level_1",
      "symbolId": 401,
      "svgPath": "port/generated/levels/level_1/1.svg",
      "imagePath": "port/generated/levels_png/level_1/1.png",
      "foregroundSvgPath": "port/generated/levels_fg/level_1/1.svg",
      "layout": {
        "imageWidth": 5564.9,
        "imageHeight": 2186.2,
        "imageOffsetX": -2220.0,
        "imageOffsetY": -493.65,
        "namedChildren": {
          "backGroundMC": {
            "x": -411.5,
            "y": 123.0,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "startPlatform": {
            "x": -20.0,
            "y": 270.0,
            "width": 202.65,
            "height": 31.5,
            "rotation": 0.0
          },
          "barier": {
            "x": 334.0,
            "y": 221.0,
            "width": 21.5,
            "height": 51.0,
            "rotation": 0.0
          },
          "exitPlatform": {
            "x": 240.0,
            "y": 270.0,
            "width": 297.8,
            "height": 31.2,
            "rotation": 0.0
          },
          "levelAim": {
            "x": 495.1,
            "y": 239.7,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": 16.9,
            "y": 249.3,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5595,
        "sourceHeight": 2217,
        "cropX": 8,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2201
      },
      "symbols": {
        "backGroundMC": {
          "symbolId": 30,
          "svgPath": "port/generated/symbols/30/svg/1.svg",
          "imagePath": "port/generated/symbols/30/png/1.png",
          "layout": {
            "imageWidth": 5564.9,
            "imageHeight": 2186.2,
            "imageOffsetX": -1808.5,
            "imageOffsetY": -616.65
          },
          "pngLayout": {
            "sourceWidth": 5595,
            "sourceHeight": 2217,
            "cropX": 8,
            "cropY": 8,
            "cropWidth": 5578,
            "cropHeight": 2201
          }
        },
        "startPlatform": {
          "symbolId": 395,
          "svgPath": "port/generated/symbols/395/svg/1.svg",
          "imagePath": "port/generated/symbols/395/png/1.png",
          "layout": {
            "imageWidth": 202.65,
            "imageHeight": 31.5,
            "imageOffsetX": -0.5,
            "imageOffsetY": -11.0
          },
          "pngLayout": {
            "sourceWidth": 203,
            "sourceHeight": 32,
            "cropX": 0,
            "cropY": 0,
            "cropWidth": 203,
            "cropHeight": 32
          }
        },
        "barier": {
          "symbolId": 397,
          "svgPath": "port/generated/symbols/397/svg/1.svg",
          "imagePath": "port/generated/symbols/397/png/1.png",
          "layout": {
            "imageWidth": 21.5,
            "imageHeight": 51.0,
            "imageOffsetX": -0.55,
            "imageOffsetY": -0.5
          },
          "pngLayout": {
            "sourceWidth": 22,
            "sourceHeight": 51,
            "cropX": 0,
            "cropY": 0,
            "cropWidth": 22,
            "cropHeight": 51
          }
        },
        "exitPlatform": {
          "symbolId": 400,
          "svgPath": "port/generated/symbols/400/svg/1.svg",
          "imagePath": "port/generated/symbols/400/png/1.png",
          "layout": {
            "imageWidth": 297.8,
            "imageHeight": 31.2,
            "imageOffsetX": -0.5,
            "imageOffsetY": -10.7
          },
          "pngLayout": {
            "sourceWidth": 298,
            "sourceHeight": 32,
            "cropX": 0,
            "cropY": 0,
            "cropWidth": 298,
            "cropHeight": 32
          }
        },
        "levelAim": {
          "symbolId": 68,
          "svgPath": "port/generated/symbols/68/svg/1.svg",
          "imagePath": "port/generated/symbols/68/png/1.png",
          "layout": {
            "imageWidth": 25.2,
            "imageHeight": 46.5,
            "imageOffsetX": -1.0,
            "imageOffsetY": -15.2
          },
          "pngLayout": {
            "sourceWidth": 26,
            "sourceHeight": 47,
            "cropX": 0,
            "cropY": 6,
            "cropWidth": 16,
            "cropHeight": 41
          }
        },
        "checkPoint0": {
          "symbolId": 85,
          "svgPath": "port/generated/symbols/85/svg/1.svg",
          "imagePath": "port/generated/symbols/85/png/1.png",
          "layout": {
            "imageWidth": 10.8,
            "imageHeight": 21.1,
            "imageOffsetX": -0.5,
            "imageOffsetY": -0.5
          },
          "pngLayout": {
            "sourceWidth": 11,
            "sourceHeight": 22,
            "cropX": 0,
            "cropY": 0,
            "cropWidth": 11,
            "cropHeight": 21
          }
        }
      },
      "bodies": [
        {
          "name": "startPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                200,
                0
              ],
              [
                200,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "exitPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                300,
                0
              ],
              [
                300,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "barier",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                0,
                0
              ],
              [
                20,
                0
              ],
              [
                20,
                50
              ],
              [
                0,
                50
              ]
            ]
          ]
        }
      ]
    },
    {
      "id": 2,
      "className": "Levels.Level_2",
      "symbolId": 355,
      "svgPath": "port/generated/levels/level_2/1.svg",
      "imagePath": "port/generated/levels_png/level_2/1.png",
      "foregroundSvgPath": "port/generated/levels_fg/level_2/1.svg",
      "layout": {
        "imageWidth": 5564.9,
        "imageHeight": 2186.2,
        "imageOffsetX": -2546.15,
        "imageOffsetY": -685.4,
        "namedChildren": {
          "backGroundMC": {
            "x": -737.65,
            "y": -68.75,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "levelAim": {
            "x": 732.7,
            "y": 353.7,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "firstPlatform": {
            "x": -470.0,
            "y": 385.0,
            "width": 167.0,
            "height": 30.1,
            "rotation": 0.0
          },
          "triangleBarier": {
            "x": -197.5,
            "y": 319.0,
            "width": 69.0,
            "height": 53.0,
            "rotation": 0.0
          },
          "platformTriangle": {
            "x": -245.0,
            "y": 385.0,
            "width": 167.0,
            "height": 29.3,
            "rotation": 0.0
          },
          "ballPlatform": {
            "x": -3.0,
            "y": 385.0,
            "width": 167.0,
            "height": 29.8,
            "rotation": 0.0
          },
          "kickBall": {
            "x": 135.5,
            "y": 298.5,
            "width": 398.1,
            "height": 309.5,
            "rotation": 0.0
          },
          "jump1": {
            "x": 230.0,
            "y": 385.0,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "movePlatform": {
            "x": 390.0,
            "y": 390.0,
            "width": 179.85,
            "height": 140.4,
            "rotation": 0.0
          },
          "exitPlatform": {
            "x": 611.0,
            "y": 385.0,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "checkPoint1": {
            "x": -103.4,
            "y": 366.2,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": -442.55,
            "y": 363.85,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5595,
        "sourceHeight": 2217,
        "cropX": 8,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2201
      },
      "symbols": {
        "backGroundMC": {
          "symbolId": 30,
          "svgPath": "port/generated/symbols/30/svg/1.svg",
          "imagePath": "port/generated/symbols/30/png/1.png",
          "layout": {
            "imageWidth": 5564.9,
            "imageHeight": 2186.2,
            "imageOffsetX": -1808.5,
            "imageOffsetY": -616.65
          },
          "pngLayout": {
            "sourceWidth": 5595,
            "sourceHeight": 2217,
            "cropX": 8,
            "cropY": 8,
            "cropWidth": 5578,
            "cropHeight": 2201
          }
        },
        "levelAim": {
          "symbolId": 68,
          "svgPath": "port/generated/symbols/68/svg/1.svg",
          "imagePath": "port/generated/symbols/68/png/1.png",
          "layout": {
            "imageWidth": 25.2,
            "imageHeight": 46.5,
            "imageOffsetX": -1.0,
            "imageOffsetY": -15.2
          },
          "pngLayout": {
            "sourceWidth": 26,
            "sourceHeight": 47,
            "cropX": 0,
            "cropY": 6,
            "cropWidth": 16,
            "cropHeight": 41
          }
        },
        "firstPlatform": {
          "symbolId": 330,
          "svgPath": "port/generated/symbols/330/svg/1.svg",
          "imagePath": "port/generated/symbols/330/png/1.png",
          "layout": {
            "imageWidth": 167.0,
            "imageHeight": 30.1,
            "imageOffsetX": -0.5,
            "imageOffsetY": -9.55
          },
          "pngLayout": {
            "sourceWidth": 167,
            "sourceHeight": 31,
            "cropX": 0,
            "cropY": 0,
            "cropWidth": 167,
            "cropHeight": 31
          }
        },
        "triangleBarier": {
          "symbolId": 332,
          "svgPath": "port/generated/symbols/332/svg/1.svg",
          "imagePath": "port/generated/symbols/332/png/1.png",
          "layout": {
            "imageWidth": 69.0,
            "imageHeight": 53.0,
            "imageOffsetX": -0.5,
            "imageOffsetY": 14.5
          },
          "pngLayout": {
            "sourceWidth": 69,
            "sourceHeight": 53,
            "cropX": 0,
            "cropY": 0,
            "cropWidth": 69,
            "cropHeight": 53
          }
        },
        "platformTriangle": {
          "symbolId": 335,
          "svgPath": "port/generated/symbols/335/svg/1.svg",
          "imagePath": "port/generated/symbols/335/png/1.png",
          "layout": {
            "imageWidth": 167.0,
            "imageHeight": 29.3,
            "imageOffsetX": -0.5,
            "imageOffsetY": -8.8
          },
          "pngLayout": {
            "sourceWidth": 167,
            "sourceHeight": 30,
            "cropX": 0,
            "cropY": 0,
            "cropWidth": 167,
            "cropHeight": 30
          }
        },
        "ballPlatform": {
          "symbolId": 337,
          "svgPath": "port/generated/symbols/337/svg/1.svg",
          "imagePath": "port/generated/symbols/337/png/1.png",
          "layout": {
            "imageWidth": 167.0,
            "imageHeight": 29.8,
            "imageOffsetX": -0.5,
            "imageOffsetY": -9.3
          },
          "pngLayout": {
            "sourceWidth": 167,
            "sourceHeight": 30,
            "cropX": 0,
            "cropY": 0,
            "cropWidth": 167,
            "cropHeight": 30
          }
        },
        "kickBall": {
          "symbolId": 341,
          "svgPath": "port/generated/symbols/341/svg/1.svg",
          "imagePath": "port/generated/symbols/341/png/1.png",
          "layout": {
            "imageWidth": 398.1,
            "imageHeight": 309.5,
            "imageOffsetX": -323.65,
            "imageOffsetY": -79.7
          },
          "pngLayout": {
            "sourceWidth": 399,
            "sourceHeight": 310,
            "cropX": 323,
            "cropY": 79,
            "cropWidth": 56,
            "cropHeight": 56
          }
        },
        "jump1": {
          "symbolId": 344,
          "svgPath": "port/generated/symbols/344/svg/1.svg",
          "imagePath": "port/generated/symbols/344/png/1.png",
          "layout": {
            "imageWidth": 502.95,
            "imageHeight": 300.5,
            "imageOffsetX": -127.1,
            "imageOffsetY": -124.5
          },
          "pngLayout": {
            "sourceWidth": 503,
            "sourceHeight": 301,
            "cropX": 126,
            "cropY": 114,
            "cropWidth": 102,
            "cropHeight": 31
          }
        },
        "movePlatform": {
          "symbolId": 347,
          "svgPath": "port/generated/symbols/347/svg/1.svg",
          "imagePath": "port/generated/symbols/347/png/1.png",
          "layout": {
            "imageWidth": 179.85,
            "imageHeight": 140.4,
            "imageOffsetX": -53.65,
            "imageOffsetY": -54.2
          },
          "pngLayout": {
            "sourceWidth": 180,
            "sourceHeight": 141,
            "cropX": 13,
            "cropY": 48,
            "cropWidth": 82,
            "cropHeight": 12
          }
        },
        "exitPlatform": {
          "symbolId": 350,
          "svgPath": "port/generated/symbols/350/svg/1.svg",
          "imagePath": "port/generated/symbols/350/png/1.png",
          "layout": {
            "imageWidth": 502.95,
            "imageHeight": 300.5,
            "imageOffsetX": -71.15,
            "imageOffsetY": -94.5
          },
          "pngLayout": {
            "sourceWidth": 503,
            "sourceHeight": 301,
            "cropX": 70,
            "cropY": 85,
            "cropWidth": 169,
            "cropHeight": 30
          }
        },
        "checkPoint1": {
          "symbolId": 85,
          "svgPath": "port/generated/symbols/85/svg/1.svg",
          "imagePath": "port/generated/symbols/85/png/1.png",
          "layout": {
            "imageWidth": 10.8,
            "imageHeight": 21.1,
            "imageOffsetX": -0.5,
            "imageOffsetY": -0.5
          },
          "pngLayout": {
            "sourceWidth": 11,
            "sourceHeight": 22,
            "cropX": 0,
            "cropY": 0,
            "cropWidth": 11,
            "cropHeight": 21
          }
        },
        "checkPoint0": {
          "symbolId": 85,
          "svgPath": "port/generated/symbols/85/svg/1.svg",
          "imagePath": "port/generated/symbols/85/png/1.png",
          "layout": {
            "imageWidth": 10.8,
            "imageHeight": 21.1,
            "imageOffsetX": -0.5,
            "imageOffsetY": -0.5
          },
          "pngLayout": {
            "sourceWidth": 11,
            "sourceHeight": 22,
            "cropX": 0,
            "cropY": 0,
            "cropWidth": 11,
            "cropHeight": 21
          }
        }
      },
      "bodies": [
        {
          "name": "firstPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                166,
                0
              ],
              [
                166,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "platformTriangle",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                166,
                0
              ],
              [
                166,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "triangleBarier",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                68,
                67
              ],
              [
                0,
                67
              ],
              [
                68,
                15
              ]
            ]
          ]
        },
        {
          "name": "ballPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                166,
                0
              ],
              [
                166,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "kickBall",
          "shape": "Circle",
          "density": 3.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            54
          ]
        },
        {
          "name": "jump1",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "movePlatform",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 3.0,
          "restitution": 0.2,
          "data": [
            [
              [
                40,
                -5
              ],
              [
                40,
                5
              ],
              [
                -40,
                5
              ],
              [
                -40,
                -5
              ]
            ]
          ]
        },
        {
          "name": "exitPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                166,
                0
              ],
              [
                166,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        }
      ]
    },
    {
      "id": 3,
      "className": "Levels.Level_3",
      "symbolId": 575,
      "svgPath": "port/generated/levels/level_3/1.svg",
      "imagePath": "port/generated/levels_png/level_3/1.png",
      "foregroundSvgPath": "port/generated/levels_fg/level_3/1.svg",
      "layout": {
        "imageWidth": 5564.9,
        "imageHeight": 2381.6,
        "imageOffsetX": -2466.35,
        "imageOffsetY": -718.8,
        "namedChildren": {
          "backGroundMC": {
            "x": -657.85,
            "y": -47.05,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "levelAim": {
            "x": 614.15,
            "y": 87.45,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "firstPlatform": {
            "x": 0.0,
            "y": 425.0,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "shipPlatform1": {
            "x": 217.0,
            "y": 424.5,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "shipPlatform2": {
            "x": 217.0,
            "y": 271.05,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "movePlatform1": {
            "x": 490.0,
            "y": 425.0,
            "width": 207.9,
            "height": 98.3,
            "rotation": 0.0
          },
          "movePlatform2": {
            "x": 45.0,
            "y": 270.5,
            "width": 207.9,
            "height": 98.3,
            "rotation": 0.0
          },
          "exitPlatform": {
            "x": 217.0,
            "y": 117.5,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "ship1": {
            "x": 314.0,
            "y": 425.0,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "ship3": {
            "x": 314.0,
            "y": 118.0,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "ship2": {
            "x": 314.0,
            "y": 272.0,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": 38.9,
            "y": 405.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint1": {
            "x": 434.85,
            "y": 249.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5595,
        "sourceHeight": 2412,
        "cropX": 8,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2396
      },
      "symbols": {
        "backGroundMC": {
          "symbolId": 30,
          "svgPath": "port/generated/symbols/30/svg/1.svg",
          "imagePath": "port/generated/symbols/30/png/1.png",
          "layout": {
            "imageWidth": 5564.9,
            "imageHeight": 2186.2,
            "imageOffsetX": -1808.5,
            "imageOffsetY": -616.65
          },
          "pngLayout": {
            "sourceWidth": 5595,
            "sourceHeight": 2217,
            "cropX": 8,
            "cropY": 8,
            "cropWidth": 5578,
            "cropHeight": 2201
          }
        },
        "levelAim": {
          "symbolId": 68,
          "svgPath": "port/generated/symbols/68/svg/1.svg",
          "imagePath": "port/generated/symbols/68/png/1.png",
          "layout": {
            "imageWidth": 25.2,
            "imageHeight": 46.5,
            "imageOffsetX": -1.0,
            "imageOffsetY": -15.2
          },
          "pngLayout": {
            "sourceWidth": 26,
            "sourceHeight": 47,
            "cropX": 0,
            "cropY": 6,
            "cropWidth": 16,
            "cropHeight": 41
          }
        },
        "firstPlatform": {
          "symbolId": 564,
          "svgPath": "port/generated/symbols/564/svg/1.svg",
          "imagePath": "port/generated/symbols/564/png/1.png",
          "layout": {
            "imageWidth": 502.95,
            "imageHeight": 300.5,
            "imageOffsetX": -277.1,
            "imageOffsetY": -151.5
          },
          "pngLayout": {
            "sourceWidth": 503,
            "sourceHeight": 301,
            "cropX": 276,
            "cropY": 141,
            "cropWidth": 152,
            "cropHeight": 31
          }
        },
        "shipPlatform1": {
          "symbolId": 567,
          "svgPath": "port/generated/symbols/567/svg/1.svg",
          "imagePath": "port/generated/symbols/567/png/1.png",
          "layout": {
            "imageWidth": 502.95,
            "imageHeight": 300.5,
            "imageOffsetX": -107.1,
            "imageOffsetY": -141.5
          },
          "pngLayout": {
            "sourceWidth": 503,
            "sourceHeight": 301,
            "cropX": 106,
            "cropY": 132,
            "cropWidth": 252,
            "cropHeight": 30
          }
        },
        "shipPlatform2": {
          "symbolId": 567,
          "svgPath": "port/generated/symbols/567/svg/1.svg",
          "imagePath": "port/generated/symbols/567/png/1.png",
          "layout": {
            "imageWidth": 502.95,
            "imageHeight": 300.5,
            "imageOffsetX": -107.1,
            "imageOffsetY": -141.5
          },
          "pngLayout": {
            "sourceWidth": 503,
            "sourceHeight": 301,
            "cropX": 106,
            "cropY": 132,
            "cropWidth": 252,
            "cropHeight": 30
          }
        },
        "movePlatform1": {
          "symbolId": 570,
          "svgPath": "port/generated/symbols/570/svg/1.svg",
          "imagePath": "port/generated/symbols/570/png/1.png",
          "layout": {
            "imageWidth": 207.9,
            "imageHeight": 98.3,
            "imageOffsetX": -44.45,
            "imageOffsetY": -44.65
          },
          "pngLayout": {
            "sourceWidth": 208,
            "sourceHeight": 99,
            "cropX": 43,
            "cropY": 44,
            "cropWidth": 152,
            "cropHeight": 12
          }
        },
        "movePlatform2": {
          "symbolId": 570,
          "svgPath": "port/generated/symbols/570/svg/1.svg",
          "imagePath": "port/generated/symbols/570/png/1.png",
          "layout": {
            "imageWidth": 207.9,
            "imageHeight": 98.3,
            "imageOffsetX": -44.45,
            "imageOffsetY": -44.65
          },
          "pngLayout": {
            "sourceWidth": 208,
            "sourceHeight": 99,
            "cropX": 43,
            "cropY": 44,
            "cropWidth": 152,
            "cropHeight": 12
          }
        },
        "exitPlatform": {
          "symbolId": 572,
          "svgPath": "port/generated/symbols/572/svg/1.svg",
          "imagePath": "port/generated/symbols/572/png/1.png",
          "layout": {
            "imageWidth": 502.95,
            "imageHeight": 300.5,
            "imageOffsetX": -31.95,
            "imageOffsetY": -62.5
          },
          "pngLayout": {
            "sourceWidth": 503,
            "sourceHeight": 301,
            "cropX": 29,
            "cropY": 52,
            "cropWidth": 454,
            "cropHeight": 31
          }
        },
        "ship1": {
          "symbolId": 58,
          "svgPath": "port/generated/symbols/58/svg/1.svg",
          "imagePath": "port/generated/symbols/58/png/1.png",
          "layout": {
            "imageWidth": 66.0,
            "imageHeight": 9.65,
            "imageOffsetX": -0.0,
            "imageOffsetY": -9.65
          },
          "pngLayout": {
            "sourceWidth": 66,
            "sourceHeight": 10,
            "cropX": 0,
            "cropY": 0,
            "cropWidth": 66,
            "cropHeight": 10
          }
        },
        "ship3": {
          "symbolId": 58,
          "svgPath": "port/generated/symbols/58/svg/1.svg",
          "imagePath": "port/generated/symbols/58/png/1.png",
          "layout": {
            "imageWidth": 66.0,
            "imageHeight": 9.65,
            "imageOffsetX": -0.0,
            "imageOffsetY": -9.65
          },
          "pngLayout": {
            "sourceWidth": 66,
            "sourceHeight": 10,
            "cropX": 0,
            "cropY": 0,
            "cropWidth": 66,
            "cropHeight": 10
          }
        },
        "ship2": {
          "symbolId": 58,
          "svgPath": "port/generated/symbols/58/svg/1.svg",
          "imagePath": "port/generated/symbols/58/png/1.png",
          "layout": {
            "imageWidth": 66.0,
            "imageHeight": 9.65,
            "imageOffsetX": -0.0,
            "imageOffsetY": -9.65
          },
          "pngLayout": {
            "sourceWidth": 66,
            "sourceHeight": 10,
            "cropX": 0,
            "cropY": 0,
            "cropWidth": 66,
            "cropHeight": 10
          }
        },
        "checkPoint0": {
          "symbolId": 85,
          "svgPath": "port/generated/symbols/85/svg/1.svg",
          "imagePath": "port/generated/symbols/85/png/1.png",
          "layout": {
            "imageWidth": 10.8,
            "imageHeight": 21.1,
            "imageOffsetX": -0.5,
            "imageOffsetY": -0.5
          },
          "pngLayout": {
            "sourceWidth": 11,
            "sourceHeight": 22,
            "cropX": 0,
            "cropY": 0,
            "cropWidth": 11,
            "cropHeight": 21
          }
        },
        "checkPoint1": {
          "symbolId": 85,
          "svgPath": "port/generated/symbols/85/svg/1.svg",
          "imagePath": "port/generated/symbols/85/png/1.png",
          "layout": {
            "imageWidth": 10.8,
            "imageHeight": 21.1,
            "imageOffsetX": -0.5,
            "imageOffsetY": -0.5
          },
          "pngLayout": {
            "sourceWidth": 11,
            "sourceHeight": 22,
            "cropX": 0,
            "cropY": 0,
            "cropWidth": 11,
            "cropHeight": 21
          }
        }
      },
      "bodies": [
        {
          "name": "firstPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                150,
                0
              ],
              [
                150,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "shipPlatform1",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                250,
                0
              ],
              [
                250,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "shipPlatform2",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                250,
                0
              ],
              [
                250,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "movePlatform1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                150,
                0
              ],
              [
                150,
                10
              ],
              [
                0,
                10
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "movePlatform2",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                150,
                0
              ],
              [
                150,
                10
              ],
              [
                0,
                10
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "exitPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                450,
                0
              ],
              [
                450,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        }
      ]
    },
    {
      "id": 4,
      "className": "Levels.Level_4",
      "symbolId": 561,
      "svgPath": "port/generated/levels/level_4/1.svg",
      "imagePath": "port/generated/levels_png/level_4/1.png",
      "foregroundSvgPath": null,
      "layout": {
        "imageWidth": 5564.9,
        "imageHeight": 2186.2,
        "imageOffsetX": -2798.2,
        "imageOffsetY": -717.35,
        "namedChildren": {
          "backGroundMC": {
            "x": -989.7,
            "y": -100.7,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "mainPlatform": {
            "x": -599.95,
            "y": 440.0,
            "width": 920.7,
            "height": 300.5,
            "rotation": 0.0
          },
          "firstFloor": {
            "x": -600.0,
            "y": 260.0,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "secondFloor1": {
            "x": -355.0,
            "y": 260.0,
            "width": 584.0,
            "height": 529.8,
            "rotation": 0.0
          },
          "killBoom1": {
            "x": -377.5,
            "y": 435.5,
            "width": 261.0,
            "height": 422.95,
            "rotation": 0.0
          },
          "killBoom2": {
            "x": -232.5,
            "y": 334.0,
            "width": 261.0,
            "height": 422.95,
            "rotation": 0.0
          },
          "secondFloor2": {
            "x": -210.0,
            "y": 260.0,
            "width": 584.0,
            "height": 529.8,
            "rotation": 0.0
          },
          "killBoom3": {
            "x": -87.5,
            "y": 435.5,
            "width": 261.0,
            "height": 422.95,
            "rotation": 0.0
          },
          "secondFloor3": {
            "x": -65.0,
            "y": 260.0,
            "width": 584.0,
            "height": 529.8,
            "rotation": 0.0
          },
          "step": {
            "x": 100.0,
            "y": 319.0,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "axePlatform": {
            "x": 508.05,
            "y": 308.6,
            "width": 920.7,
            "height": 300.5,
            "rotation": 0.0
          },
          "axe1": {
            "x": 756.7,
            "y": 145.55,
            "width": 67.8,
            "height": 176.35,
            "rotation": -47.65988874595731
          },
          "axe2": {
            "x": 1060.95,
            "y": 96.2,
            "width": 67.8,
            "height": 176.35,
            "rotation": 47.366516063520145
          },
          "levelAim": {
            "x": 1295.2,
            "y": 277.2,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "dropPlatform": {
            "x": 339.45,
            "y": 308.5,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "checkPoint1": {
            "x": 233.35,
            "y": 288.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": -561.05,
            "y": 419.85,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5595,
        "sourceHeight": 2217,
        "cropX": 8,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2201
      },
      "symbols": {},
      "bodies": [
        {
          "name": "mainPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                810,
                0
              ],
              [
                810,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "firstFloor",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                200,
                0
              ],
              [
                200,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "secondFloor1",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "secondFloor2",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "secondFloor3",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "step",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                117,
                -10
              ],
              [
                202,
                -10
              ],
              [
                117,
                12
              ]
            ],
            [
              [
                92,
                12
              ],
              [
                117,
                12
              ],
              [
                92,
                34
              ]
            ],
            [
              [
                117,
                12
              ],
              [
                202,
                -10
              ],
              [
                150,
                16
              ],
              [
                92,
                34
              ]
            ],
            [
              [
                70,
                34
              ],
              [
                92,
                34
              ],
              [
                150,
                122
              ],
              [
                70,
                57
              ]
            ],
            [
              [
                45,
                57
              ],
              [
                70,
                57
              ],
              [
                45,
                76
              ]
            ],
            [
              [
                24,
                76
              ],
              [
                45,
                76
              ],
              [
                24,
                99
              ]
            ],
            [
              [
                45,
                76
              ],
              [
                70,
                57
              ],
              [
                24,
                99
              ]
            ],
            [
              [
                0,
                99
              ],
              [
                24,
                99
              ],
              [
                0,
                122
              ]
            ],
            [
              [
                24,
                99
              ],
              [
                70,
                57
              ],
              [
                150,
                122
              ],
              [
                0,
                122
              ]
            ],
            [
              [
                150,
                122
              ],
              [
                92,
                34
              ],
              [
                150,
                16
              ]
            ],
            [
              [
                202,
                16
              ],
              [
                150,
                16
              ],
              [
                202,
                -10
              ]
            ]
          ]
        },
        {
          "name": "dropPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                130,
                0
              ],
              [
                130,
                10
              ],
              [
                0,
                10
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "axePlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                850,
                0
              ],
              [
                850,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "killBoom1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                19.5,
                -267.5
              ],
              [
                19.5,
                -31.5
              ],
              [
                -19.5,
                -31.5
              ],
              [
                -19.5,
                -267.5
              ]
            ],
            [
              [
                -19.5,
                -31.5
              ],
              [
                19.5,
                -31.5
              ],
              [
                50.5,
                0.5
              ],
              [
                -47.5,
                0.5
              ]
            ]
          ]
        },
        {
          "name": "killBoom2",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                19.5,
                -267.5
              ],
              [
                19.5,
                -31.5
              ],
              [
                -19.5,
                -31.5
              ],
              [
                -19.5,
                -267.5
              ]
            ],
            [
              [
                -19.5,
                -31.5
              ],
              [
                19.5,
                -31.5
              ],
              [
                50.5,
                0.5
              ],
              [
                -47.5,
                0.5
              ]
            ]
          ]
        },
        {
          "name": "killBoom3",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                19.5,
                -267.5
              ],
              [
                19.5,
                -31.5
              ],
              [
                -19.5,
                -31.5
              ],
              [
                -19.5,
                -267.5
              ]
            ],
            [
              [
                -19.5,
                -31.5
              ],
              [
                19.5,
                -31.5
              ],
              [
                50.5,
                0.5
              ],
              [
                -47.5,
                0.5
              ]
            ]
          ]
        },
        {
          "name": "axe1",
          "shape": "Polygon",
          "density": 2.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                25.5,
                -1.5
              ],
              [
                40.5,
                -1.5
              ],
              [
                40.5,
                113.5
              ],
              [
                25.5,
                113.5
              ]
            ],
            [
              [
                0.5,
                116.5
              ],
              [
                25.5,
                113.5
              ],
              [
                40.5,
                113.5
              ],
              [
                67.5,
                116.5
              ],
              [
                67.5,
                175.5
              ],
              [
                0.5,
                175.5
              ]
            ]
          ]
        },
        {
          "name": "axe2",
          "shape": "Polygon",
          "density": 2.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                25.5,
                -1.5
              ],
              [
                40.5,
                -1.5
              ],
              [
                40.5,
                113.5
              ],
              [
                25.5,
                113.5
              ]
            ],
            [
              [
                0.5,
                116.5
              ],
              [
                25.5,
                113.5
              ],
              [
                40.5,
                113.5
              ],
              [
                67.5,
                116.5
              ],
              [
                67.5,
                175.5
              ],
              [
                0.5,
                175.5
              ]
            ]
          ]
        },
        {
          "name": "dropPlatform",
          "shape": "Polygon",
          "density": 3.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                130,
                0
              ],
              [
                130,
                10
              ],
              [
                0,
                10
              ],
              [
                0,
                0
              ]
            ]
          ]
        }
      ]
    },
    {
      "id": 5,
      "className": "Levels.Level_5",
      "symbolId": 125,
      "svgPath": "port/generated/levels/level_5/1.svg",
      "imagePath": "port/generated/levels_png/level_5/1.png",
      "foregroundSvgPath": null,
      "layout": {
        "imageWidth": 5564.9,
        "imageHeight": 2186.2,
        "imageOffsetX": -2555.05,
        "imageOffsetY": -760.5,
        "namedChildren": {
          "backGroundMC": {
            "x": -746.55,
            "y": -143.85,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "greenPlatform": {
            "x": 363.45,
            "y": 170.5,
            "width": 242.6,
            "height": 196.6,
            "rotation": 0.0
          },
          "blueCheck": {
            "x": -191.0,
            "y": 367.0,
            "width": 11.0,
            "height": 11.0,
            "rotation": 0.0
          },
          "greenCheck": {
            "x": 266.8,
            "y": 262.35,
            "width": 11.0,
            "height": 11.0,
            "rotation": 0.0
          },
          "levelAim": {
            "x": 223.55,
            "y": 97.55,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "blueBarier": {
            "x": -126.95,
            "y": 308.0,
            "width": 337.65,
            "height": 216.7,
            "rotation": 0.0
          },
          "mainPlatform": {
            "x": -116.95,
            "y": 291.95,
            "width": 671.2,
            "height": 300.5,
            "rotation": 0.0
          },
          "rightBarier": {
            "x": 447.95,
            "y": 41.0,
            "width": 220.7,
            "height": 278.25,
            "rotation": 0.0
          },
          "littleBall": {
            "x": 318.75,
            "y": 278.45,
            "width": 199.95,
            "height": 100.05,
            "rotation": 0.0
          },
          "jumpPlatform": {
            "x": 204.35,
            "y": 270.95,
            "width": 398.9,
            "height": 206.5,
            "rotation": 0.0
          },
          "bigBall": {
            "x": 363.95,
            "y": 86.5,
            "width": 403.75,
            "height": 266.2,
            "rotation": 0.0
          },
          "firstPlatform": {
            "x": -414.95,
            "y": 407.95,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": -383.1,
            "y": 388.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5595,
        "sourceHeight": 2217,
        "cropX": 8,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2201
      },
      "symbols": {},
      "bodies": [
        {
          "name": "firstPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                298.45,
                0
              ],
              [
                298.45,
                0.3
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ],
            [
              [
                298.45,
                0.3
              ],
              [
                300,
                0.3
              ],
              [
                300,
                20
              ],
              [
                0,
                20
              ]
            ]
          ]
        },
        {
          "name": "blueBarier",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                0,
                0
              ],
              [
                10,
                0
              ],
              [
                10,
                100
              ],
              [
                0,
                100
              ]
            ]
          ]
        },
        {
          "name": "mainPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                594.9,
                0
              ],
              [
                594.9,
                136
              ],
              [
                0,
                136
              ],
              [
                0,
                116
              ],
              [
                195.95,
                0
              ]
            ]
          ]
        },
        {
          "name": "rightBarier",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                0,
                0
              ],
              [
                30,
                0
              ],
              [
                1.05,
                251
              ],
              [
                0,
                251
              ]
            ],
            [
              [
                1.05,
                251
              ],
              [
                30,
                0
              ],
              [
                30,
                251.95
              ],
              [
                1.05,
                251.95
              ]
            ]
          ]
        },
        {
          "name": "jumpPlatform",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                226.95,
                0
              ],
              [
                226.95,
                7
              ],
              [
                0,
                7
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "greenPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                85,
                0
              ],
              [
                85,
                15
              ],
              [
                0,
                15
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "littleBall",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            13
          ]
        },
        {
          "name": "bigBall",
          "shape": "Circle",
          "density": 2.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            83.5
          ]
        }
      ]
    },
    {
      "id": 6,
      "className": "Levels.Level_6",
      "symbolId": 434,
      "svgPath": "port/generated/levels/level_6/1.svg",
      "imagePath": "port/generated/levels_png/level_6/1.png",
      "foregroundSvgPath": null,
      "layout": {
        "imageWidth": 5564.9,
        "imageHeight": 2186.2,
        "imageOffsetX": -2271.0,
        "imageOffsetY": -444.3,
        "namedChildren": {
          "backGroundMC": {
            "x": -462.5,
            "y": 172.35,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "rampa": {
            "x": -471.85,
            "y": 387.85,
            "width": 573.15,
            "height": 559.95,
            "rotation": 0.0
          },
          "levelAim": {
            "x": 1541.1,
            "y": 685.9,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "drop1": {
            "x": 163.95,
            "y": 357.0,
            "width": 580.5,
            "height": 545.1,
            "rotation": 0.0
          },
          "drop2": {
            "x": 309.9,
            "y": 335.0,
            "width": 580.5,
            "height": 545.1,
            "rotation": 0.0
          },
          "drop3": {
            "x": 457.9,
            "y": 311.0,
            "width": 580.5,
            "height": 545.1,
            "rotation": 0.0
          },
          "afterJump": {
            "x": -64.0,
            "y": 379.0,
            "width": 578.4,
            "height": 551.25,
            "rotation": 0.0
          },
          "spin": {
            "x": 711.95,
            "y": 319.0,
            "width": 380.0,
            "height": 214.0,
            "rotation": 0.0
          },
          "voronkaLeft": {
            "x": 661.0,
            "y": 434.0,
            "width": 231.65,
            "height": 402.75,
            "rotation": 0.0
          },
          "voronkaRight": {
            "x": 678.0,
            "y": 434.0,
            "width": 309.5,
            "height": 398.1,
            "rotation": 0.0
          },
          "rampa2": {
            "x": 541.0,
            "y": 674.0,
            "width": 606.05,
            "height": 546.75,
            "rotation": 0.0
          },
          "backBall1": {
            "x": 1184.8,
            "y": 720.0,
            "width": 402.9,
            "height": 279.45,
            "rotation": 0.0
          },
          "backBall2": {
            "x": 1295.1,
            "y": 719.95,
            "width": 402.9,
            "height": 279.45,
            "rotation": 0.0
          },
          "backBall3": {
            "x": 1403.8,
            "y": 719.95,
            "width": 402.9,
            "height": 279.45,
            "rotation": 0.0
          },
          "finishPlatform": {
            "x": 1480.8,
            "y": 717.0,
            "width": 579.25,
            "height": 548.6,
            "rotation": 0.0
          },
          "beforeBackBalls": {
            "x": 932.3,
            "y": 717.3,
            "width": 578.4,
            "height": 551.25,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": -450.1,
            "y": 367.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint1": {
            "x": 998.85,
            "y": 697.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5595,
        "sourceHeight": 2217,
        "cropX": 8,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2201
      },
      "symbols": {},
      "bodies": [
        {
          "name": "rampa",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                66.9,
                0
              ],
              [
                66.9,
                22.15
              ],
              [
                0,
                0
              ]
            ],
            [
              [
                66.9,
                22.15
              ],
              [
                69.8,
                47.2
              ],
              [
                0,
                0
              ]
            ],
            [
              [
                69.8,
                47.2
              ],
              [
                72.9,
                68.15
              ],
              [
                0,
                0
              ]
            ],
            [
              [
                72.9,
                68.15
              ],
              [
                77.9,
                90.15
              ],
              [
                0,
                0
              ]
            ],
            [
              [
                77.9,
                90.15
              ],
              [
                83.9,
                108.15
              ],
              [
                0,
                0
              ]
            ],
            [
              [
                83.9,
                108.15
              ],
              [
                92.9,
                127.15
              ],
              [
                0,
                0
              ]
            ],
            [
              [
                92.9,
                127.15
              ],
              [
                103.9,
                146.15
              ],
              [
                0,
                0
              ]
            ],
            [
              [
                103.9,
                146.15
              ],
              [
                114.9,
                162.15
              ],
              [
                0,
                261.1
              ],
              [
                0,
                0
              ]
            ],
            [
              [
                114.9,
                162.15
              ],
              [
                127.9,
                174.15
              ],
              [
                0,
                261.1
              ]
            ],
            [
              [
                127.9,
                174.15
              ],
              [
                146.35,
                187.35
              ],
              [
                0,
                261.1
              ]
            ],
            [
              [
                146.35,
                187.35
              ],
              [
                165.9,
                194.65
              ],
              [
                0,
                261.1
              ]
            ],
            [
              [
                165.9,
                194.65
              ],
              [
                183.4,
                197.65
              ],
              [
                279.9,
                261.1
              ],
              [
                0,
                261.1
              ]
            ],
            [
              [
                279.9,
                138.15
              ],
              [
                279.9,
                261.1
              ],
              [
                271.9,
                155.65
              ]
            ],
            [
              [
                271.9,
                155.65
              ],
              [
                279.9,
                261.1
              ],
              [
                261.9,
                171.65
              ]
            ],
            [
              [
                261.9,
                171.65
              ],
              [
                279.9,
                261.1
              ],
              [
                250.4,
                183.65
              ]
            ],
            [
              [
                250.4,
                183.65
              ],
              [
                279.9,
                261.1
              ],
              [
                234.9,
                194.15
              ]
            ],
            [
              [
                234.9,
                194.15
              ],
              [
                279.9,
                261.1
              ],
              [
                218.9,
                198.15
              ]
            ],
            [
              [
                218.9,
                198.15
              ],
              [
                279.9,
                261.1
              ],
              [
                200.4,
                198.65
              ]
            ],
            [
              [
                200.4,
                198.65
              ],
              [
                279.9,
                261.1
              ],
              [
                183.4,
                197.65
              ]
            ]
          ]
        },
        {
          "name": "afterJump",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                182,
                0
              ],
              [
                182,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "drop1",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "drop2",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "drop3",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "spin",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                60.55,
                -65.5
              ],
              [
                67.75,
                -58.6
              ],
              [
                26.3,
                -30.2
              ]
            ],
            [
              [
                5,
                -89.5
              ],
              [
                5,
                -39.75
              ],
              [
                -5,
                -39.75
              ],
              [
                -5,
                -89.5
              ]
            ],
            [
              [
                5,
                -39.75
              ],
              [
                26.3,
                -30.2
              ],
              [
                -24.35,
                -31.4
              ],
              [
                -24.6,
                -31.65
              ],
              [
                -5,
                -39.75
              ]
            ],
            [
              [
                -24.6,
                -31.65
              ],
              [
                -24.35,
                -31.4
              ],
              [
                -31.7,
                -24.5
              ],
              [
                -67.9,
                -57.8
              ],
              [
                -61.1,
                -65.2
              ]
            ],
            [
              [
                -24.35,
                -31.4
              ],
              [
                26.3,
                -30.2
              ],
              [
                -31.45,
                24.8
              ],
              [
                -39.8,
                4.3
              ],
              [
                -39.65,
                -5.7
              ],
              [
                -31.7,
                -24.5
              ]
            ],
            [
              [
                -88.95,
                -6.1
              ],
              [
                -39.65,
                -5.7
              ],
              [
                -39.8,
                4.3
              ],
              [
                -89.05,
                3.9
              ]
            ],
            [
              [
                26.3,
                -30.2
              ],
              [
                67.75,
                -58.6
              ],
              [
                32.8,
                -23
              ],
              [
                -24.65,
                31.55
              ],
              [
                -66.7,
                60.1
              ],
              [
                -31.45,
                24.8
              ]
            ],
            [
              [
                -31.7,
                24.55
              ],
              [
                -31.45,
                24.8
              ],
              [
                -66.7,
                60.1
              ]
            ],
            [
              [
                -59.6,
                67.1
              ],
              [
                -66.7,
                60.1
              ],
              [
                -24.65,
                31.55
              ]
            ],
            [
              [
                -4.2,
                39.8
              ],
              [
                -24.65,
                31.55
              ],
              [
                -4.2,
                39.4
              ]
            ],
            [
              [
                -4.85,
                89.4
              ],
              [
                -4.2,
                39.8
              ],
              [
                5.15,
                89.5
              ]
            ],
            [
              [
                -4.2,
                39.8
              ],
              [
                -4.2,
                39.4
              ],
              [
                5.8,
                39.6
              ],
              [
                5.15,
                89.5
              ]
            ],
            [
              [
                -4.2,
                39.4
              ],
              [
                -24.65,
                31.55
              ],
              [
                32.4,
                23
              ],
              [
                32.65,
                23.2
              ],
              [
                26.15,
                30.3
              ],
              [
                5.8,
                39.6
              ]
            ],
            [
              [
                25.9,
                30.6
              ],
              [
                26.15,
                30.3
              ],
              [
                32.65,
                23.2
              ],
              [
                70.2,
                55.6
              ],
              [
                63.7,
                63.2
              ]
            ],
            [
              [
                32.65,
                23.2
              ],
              [
                32.4,
                23
              ],
              [
                39.75,
                4.45
              ]
            ],
            [
              [
                32.4,
                23
              ],
              [
                -24.65,
                31.55
              ],
              [
                32.8,
                -23
              ],
              [
                39.65,
                -5.55
              ],
              [
                39.75,
                4.45
              ]
            ],
            [
              [
                89.05,
                4
              ],
              [
                39.75,
                4.45
              ],
              [
                39.65,
                -5.55
              ],
              [
                88.95,
                -6
              ]
            ],
            [
              [
                33,
                -22.8
              ],
              [
                32.8,
                -23
              ],
              [
                67.75,
                -58.6
              ]
            ]
          ]
        },
        {
          "name": "voronkaLeft",
          "shape": "Polygon",
          "density": 0,
          "friction": 0,
          "restitution": 0.2,
          "data": [
            [
              [
                0,
                284.45
              ],
              [
                105.5,
                224
              ],
              [
                107.5,
                227
              ],
              [
                1.5,
                288
              ]
            ],
            [
              [
                105.5,
                224
              ],
              [
                112.5,
                216.5
              ],
              [
                115.5,
                219
              ],
              [
                107.5,
                227
              ]
            ],
            [
              [
                112.5,
                216.5
              ],
              [
                115.5,
                208
              ],
              [
                115.5,
                219
              ]
            ],
            [
              [
                115.5,
                208
              ],
              [
                115.5,
                68.5
              ],
              [
                115.5,
                219
              ]
            ],
            [
              [
                115.5,
                219
              ],
              [
                115.5,
                68.5
              ],
              [
                119.5,
                67.5
              ],
              [
                119.5,
                208
              ]
            ],
            [
              [
                115.5,
                68.5
              ],
              [
                88.5,
                34.5
              ],
              [
                92.5,
                32
              ],
              [
                119.5,
                67.5
              ]
            ],
            [
              [
                88.5,
                34.5
              ],
              [
                83.5,
                0
              ],
              [
                88,
                0
              ],
              [
                92.5,
                32
              ]
            ]
          ]
        },
        {
          "name": "voronkaRight",
          "shape": "Polygon",
          "density": 0,
          "friction": 0,
          "restitution": 0.2,
          "data": [
            [
              [
                0,
                306.2
              ],
              [
                105.5,
                245.75
              ],
              [
                107.5,
                248.75
              ],
              [
                1.5,
                309.75
              ]
            ],
            [
              [
                105.5,
                245.75
              ],
              [
                113.65,
                240.2
              ],
              [
                107.5,
                248.75
              ]
            ],
            [
              [
                113.65,
                240.2
              ],
              [
                120.4,
                233.95
              ],
              [
                115.4,
                243.2
              ],
              [
                107.5,
                248.75
              ]
            ],
            [
              [
                120.4,
                233.95
              ],
              [
                124.9,
                226.45
              ],
              [
                123.4,
                235.7
              ],
              [
                115.4,
                243.2
              ]
            ],
            [
              [
                124.9,
                226.45
              ],
              [
                128.65,
                216.95
              ],
              [
                127.9,
                227.45
              ],
              [
                123.4,
                235.7
              ]
            ],
            [
              [
                128.65,
                216.95
              ],
              [
                130.25,
                207.95
              ],
              [
                131.9,
                218.2
              ],
              [
                127.9,
                227.45
              ]
            ],
            [
              [
                130.25,
                207.95
              ],
              [
                130.25,
                67.5
              ],
              [
                134.25,
                68.5
              ],
              [
                134.25,
                207.95
              ],
              [
                133.4,
                212.95
              ],
              [
                131.9,
                218.2
              ]
            ],
            [
              [
                130.25,
                67.5
              ],
              [
                157.25,
                32
              ],
              [
                161.25,
                34.5
              ],
              [
                134.25,
                68.5
              ]
            ],
            [
              [
                157.25,
                32
              ],
              [
                161.75,
                0
              ],
              [
                166.25,
                0
              ],
              [
                161.25,
                34.5
              ]
            ]
          ]
        },
        {
          "name": "rampa2",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                129.9,
                0
              ],
              [
                129.9,
                26.4
              ],
              [
                58.9,
                26.4
              ],
              [
                0,
                0
              ]
            ],
            [
              [
                279.9,
                191.15
              ],
              [
                279.9,
                284.1
              ],
              [
                271.9,
                208.65
              ]
            ],
            [
              [
                271.9,
                208.65
              ],
              [
                279.9,
                284.1
              ],
              [
                261.9,
                224.65
              ]
            ],
            [
              [
                261.9,
                224.65
              ],
              [
                279.9,
                284.1
              ],
              [
                250.4,
                236.65
              ]
            ],
            [
              [
                250.4,
                236.65
              ],
              [
                279.9,
                284.1
              ],
              [
                234.9,
                247.15
              ]
            ],
            [
              [
                234.9,
                247.15
              ],
              [
                279.9,
                284.1
              ],
              [
                218.9,
                251.15
              ]
            ],
            [
              [
                279.9,
                284.1
              ],
              [
                0,
                284.1
              ],
              [
                200.4,
                251.65
              ],
              [
                218.9,
                251.15
              ]
            ],
            [
              [
                200.4,
                251.65
              ],
              [
                0,
                284.1
              ],
              [
                183.4,
                250.65
              ]
            ],
            [
              [
                183.4,
                250.65
              ],
              [
                0,
                284.1
              ],
              [
                165.9,
                247.65
              ]
            ],
            [
              [
                165.9,
                247.65
              ],
              [
                0,
                284.1
              ],
              [
                146.35,
                240.35
              ]
            ],
            [
              [
                146.35,
                240.35
              ],
              [
                0,
                284.1
              ],
              [
                127.9,
                227.15
              ]
            ],
            [
              [
                127.9,
                227.15
              ],
              [
                0,
                284.1
              ],
              [
                114.9,
                215.15
              ]
            ],
            [
              [
                114.9,
                215.15
              ],
              [
                0,
                284.1
              ],
              [
                103.9,
                199.15
              ]
            ],
            [
              [
                103.9,
                199.15
              ],
              [
                0,
                284.1
              ],
              [
                92.9,
                180.15
              ]
            ],
            [
              [
                0,
                284.1
              ],
              [
                0,
                0
              ],
              [
                83.9,
                161.15
              ],
              [
                92.9,
                180.15
              ]
            ],
            [
              [
                83.9,
                161.15
              ],
              [
                0,
                0
              ],
              [
                77.9,
                143.15
              ]
            ],
            [
              [
                77.9,
                143.15
              ],
              [
                0,
                0
              ],
              [
                72.9,
                121.15
              ]
            ],
            [
              [
                72.9,
                121.15
              ],
              [
                0,
                0
              ],
              [
                58.9,
                26.4
              ]
            ]
          ]
        },
        {
          "name": "beforeBackBalls",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                182,
                0
              ],
              [
                182,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "backBall1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                14.75,
                -16.85
              ],
              [
                18.5,
                -12.7
              ],
              [
                22.25,
                -3.1
              ],
              [
                22.35,
                2.5
              ],
              [
                18.3,
                13
              ],
              [
                14.65,
                16.95
              ],
              [
                3.25,
                22.15
              ],
              [
                -2.4,
                22.25
              ],
              [
                -13.85,
                17.7
              ],
              [
                -17.65,
                13.9
              ],
              [
                -22.35,
                2.4
              ],
              [
                -22.25,
                -3.15
              ],
              [
                -17.8,
                -13.65
              ],
              [
                -13.8,
                -17.65
              ],
              [
                -2.85,
                -22.15
              ],
              [
                2.8,
                -22.15
              ]
            ],
            [
              [
                2.8,
                -50
              ],
              [
                2.8,
                -22.15
              ],
              [
                -2.85,
                -22.15
              ],
              [
                -2.85,
                -50
              ]
            ],
            [
              [
                -49.95,
                -3.4
              ],
              [
                -22.25,
                -3.15
              ],
              [
                -22.35,
                2.4
              ],
              [
                -50,
                2.2
              ]
            ],
            [
              [
                -2.75,
                49.95
              ],
              [
                -2.4,
                22.25
              ],
              [
                3.25,
                22.15
              ],
              [
                2.85,
                50
              ]
            ],
            [
              [
                50,
                2.25
              ],
              [
                22.35,
                2.5
              ],
              [
                22.25,
                -3.1
              ],
              [
                49.9,
                -3.35
              ]
            ]
          ]
        },
        {
          "name": "backBall2",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                14.75,
                -16.85
              ],
              [
                18.5,
                -12.7
              ],
              [
                22.25,
                -3.1
              ],
              [
                22.35,
                2.5
              ],
              [
                18.3,
                13
              ],
              [
                14.65,
                16.95
              ],
              [
                3.25,
                22.15
              ],
              [
                -2.4,
                22.25
              ],
              [
                -13.85,
                17.7
              ],
              [
                -17.65,
                13.9
              ],
              [
                -22.35,
                2.4
              ],
              [
                -22.25,
                -3.15
              ],
              [
                -17.8,
                -13.65
              ],
              [
                -13.8,
                -17.65
              ],
              [
                -2.85,
                -22.15
              ],
              [
                2.8,
                -22.15
              ]
            ],
            [
              [
                2.8,
                -50
              ],
              [
                2.8,
                -22.15
              ],
              [
                -2.85,
                -22.15
              ],
              [
                -2.85,
                -50
              ]
            ],
            [
              [
                -49.95,
                -3.4
              ],
              [
                -22.25,
                -3.15
              ],
              [
                -22.35,
                2.4
              ],
              [
                -50,
                2.2
              ]
            ],
            [
              [
                -2.75,
                49.95
              ],
              [
                -2.4,
                22.25
              ],
              [
                3.25,
                22.15
              ],
              [
                2.85,
                50
              ]
            ],
            [
              [
                50,
                2.25
              ],
              [
                22.35,
                2.5
              ],
              [
                22.25,
                -3.1
              ],
              [
                49.9,
                -3.35
              ]
            ]
          ]
        },
        {
          "name": "backBall3",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                14.75,
                -16.85
              ],
              [
                18.5,
                -12.7
              ],
              [
                22.25,
                -3.1
              ],
              [
                22.35,
                2.5
              ],
              [
                18.3,
                13
              ],
              [
                14.65,
                16.95
              ],
              [
                3.25,
                22.15
              ],
              [
                -2.4,
                22.25
              ],
              [
                -13.85,
                17.7
              ],
              [
                -17.65,
                13.9
              ],
              [
                -22.35,
                2.4
              ],
              [
                -22.25,
                -3.15
              ],
              [
                -17.8,
                -13.65
              ],
              [
                -13.8,
                -17.65
              ],
              [
                -2.85,
                -22.15
              ],
              [
                2.8,
                -22.15
              ]
            ],
            [
              [
                2.8,
                -50
              ],
              [
                2.8,
                -22.15
              ],
              [
                -2.85,
                -22.15
              ],
              [
                -2.85,
                -50
              ]
            ],
            [
              [
                -49.95,
                -3.4
              ],
              [
                -22.25,
                -3.15
              ],
              [
                -22.35,
                2.4
              ],
              [
                -50,
                2.2
              ]
            ],
            [
              [
                -2.75,
                49.95
              ],
              [
                -2.4,
                22.25
              ],
              [
                3.25,
                22.15
              ],
              [
                2.85,
                50
              ]
            ],
            [
              [
                50,
                2.25
              ],
              [
                22.35,
                2.5
              ],
              [
                22.25,
                -3.1
              ],
              [
                49.9,
                -3.35
              ]
            ]
          ]
        },
        {
          "name": "finishPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "drop1",
          "shape": "Polygon",
          "density": 3.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "drop2",
          "shape": "Polygon",
          "density": 3.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "drop3",
          "shape": "Polygon",
          "density": 3.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        }
      ]
    },
    {
      "id": 7,
      "className": "Levels.Level_7",
      "symbolId": 287,
      "svgPath": "port/generated/levels/level_7/1.svg",
      "imagePath": "port/generated/levels_png/level_7/1.png",
      "foregroundSvgPath": null,
      "layout": {
        "imageWidth": 5564.9,
        "imageHeight": 2186.2,
        "imageOffsetX": -1702.05,
        "imageOffsetY": -1006.25,
        "namedChildren": {
          "backGroundMC": {
            "x": 106.45,
            "y": -389.6,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "levelAim": {
            "x": 3248.05,
            "y": -214.4,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "firstPlatform": {
            "x": -213.9,
            "y": 260.0,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "jumpPlatform1": {
            "x": -10.25,
            "y": 260.0,
            "width": 428.1,
            "height": 309.15,
            "rotation": 0.0
          },
          "bigPlatform": {
            "x": 658.75,
            "y": 78.45,
            "width": 1159.85,
            "height": 300.5,
            "rotation": 0.0
          },
          "potolok": {
            "x": 592.95,
            "y": -185.0,
            "width": 569.05,
            "height": 300.5,
            "rotation": 0.0
          },
          "movePlatform1": {
            "x": 1324.0,
            "y": 122.0,
            "width": 202.25,
            "height": 153.1,
            "rotation": 0.0
          },
          "movePlatform2": {
            "x": 1646.0,
            "y": -31.05,
            "width": 202.25,
            "height": 153.1,
            "rotation": 0.0
          },
          "redCheck": {
            "x": 389.85,
            "y": -286.55,
            "width": 11.0,
            "height": 11.0,
            "rotation": 0.0
          },
          "box1": {
            "x": 718.75,
            "y": -274.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box2": {
            "x": 740.75,
            "y": -274.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box3": {
            "x": 762.75,
            "y": -274.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box4": {
            "x": 718.75,
            "y": -296.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box5": {
            "x": 740.75,
            "y": -296.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box6": {
            "x": 762.75,
            "y": -296.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box7": {
            "x": 718.75,
            "y": -318.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box8": {
            "x": 740.75,
            "y": -318.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box9": {
            "x": 762.75,
            "y": -318.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box10": {
            "x": 718.75,
            "y": -340.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box11": {
            "x": 740.75,
            "y": -340.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box12": {
            "x": 762.75,
            "y": -340.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box13": {
            "x": 718.75,
            "y": -362.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box14": {
            "x": 740.75,
            "y": -362.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box15": {
            "x": 762.75,
            "y": -362.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box16": {
            "x": 718.75,
            "y": -384.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box17": {
            "x": 740.75,
            "y": -384.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "box18": {
            "x": 762.75,
            "y": -384.45,
            "width": 81.5,
            "height": 74.2,
            "rotation": 0.0
          },
          "redWall": {
            "x": 2042.45,
            "y": -234.5,
            "width": 122.4,
            "height": 188.35,
            "rotation": 0.0
          },
          "endPlatform": {
            "x": 3156.2,
            "y": -183.05,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "jumpPlatform2": {
            "x": 1745.1,
            "y": -37.0,
            "width": 428.1,
            "height": 309.15,
            "rotation": 0.0
          },
          "triangle": {
            "x": 1293.9,
            "y": -206.95,
            "width": 873.45,
            "height": 344.55,
            "rotation": 0.0
          },
          "vanna": {
            "x": 2322.35,
            "y": -83.45,
            "width": 895.65,
            "height": 300.5,
            "rotation": 0.0
          },
          "bigMovePlatform": {
            "x": 3008.85,
            "y": -184.0,
            "width": 202.25,
            "height": 153.1,
            "rotation": 0.0
          },
          "kill1": {
            "x": 2257.95,
            "y": -31.8,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "kill2": {
            "x": 2323.95,
            "y": -31.8,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "kill3": {
            "x": 2389.95,
            "y": -32.3,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "kill4": {
            "x": 2419.45,
            "y": -32.3,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "bluePlatform": {
            "x": 2294.9,
            "y": -175.0,
            "width": 416.75,
            "height": 214.45,
            "rotation": 0.0
          },
          "blueCheck": {
            "x": 2366.2,
            "y": -183.65,
            "width": 11.0,
            "height": 11.0,
            "rotation": 0.0
          },
          "shipik1": {
            "x": 439.95,
            "y": -261.8,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "shipik2": {
            "x": 806.9,
            "y": -3.8,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "star": {
            "x": 619.0,
            "y": -81.5,
            "width": 31.0,
            "height": 31.0,
            "rotation": 0.0
          },
          "shipik3": {
            "x": 506.0,
            "y": -261.8,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "shipik4": {
            "x": 572.5,
            "y": -262.25,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "shipik5": {
            "x": 638.5,
            "y": -262.25,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": -163.05,
            "y": 240.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint1": {
            "x": 1618.8,
            "y": -196.1,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint2": {
            "x": 2096.75,
            "y": -192.6,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5595,
        "sourceHeight": 2217,
        "cropX": 8,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2201
      },
      "symbols": {},
      "bodies": [
        {
          "name": "firstPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                150,
                0
              ],
              [
                150,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "jumpPlatform1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "bigPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                228.2,
                -82.45
              ],
              [
                228.2,
                -59.45
              ],
              [
                -264.8,
                -47.45
              ],
              [
                -264.8,
                -82.45
              ]
            ],
            [
              [
                -264.8,
                -47.45
              ],
              [
                228.2,
                -59.45
              ],
              [
                -339.8,
                11.55
              ]
            ],
            [
              [
                -441.75,
                11.55
              ],
              [
                -339.8,
                11.55
              ],
              [
                -527.75,
                61.5
              ]
            ],
            [
              [
                -339.8,
                11.55
              ],
              [
                228.2,
                -59.45
              ],
              [
                254.2,
                -59.45
              ],
              [
                254.2,
                -36.45
              ],
              [
                -527.75,
                82.5
              ],
              [
                -527.75,
                61.5
              ]
            ],
            [
              [
                527.75,
                29
              ],
              [
                527.75,
                82.5
              ],
              [
                512.1,
                42.5
              ]
            ],
            [
              [
                512.1,
                42.5
              ],
              [
                527.75,
                82.5
              ],
              [
                492.9,
                51.2
              ]
            ],
            [
              [
                492.9,
                51.2
              ],
              [
                527.75,
                82.5
              ],
              [
                475.55,
                53.2
              ]
            ],
            [
              [
                527.75,
                82.5
              ],
              [
                -527.75,
                82.5
              ],
              [
                457.5,
                51.7
              ],
              [
                475.55,
                53.2
              ]
            ],
            [
              [
                457.5,
                51.7
              ],
              [
                -527.75,
                82.5
              ],
              [
                415.55,
                41.25
              ]
            ],
            [
              [
                415.55,
                41.25
              ],
              [
                -527.75,
                82.5
              ],
              [
                309.2,
                8.55
              ]
            ],
            [
              [
                309.2,
                8.55
              ],
              [
                -527.75,
                82.5
              ],
              [
                280.2,
                -14.45
              ],
              [
                309.2,
                -14.45
              ]
            ],
            [
              [
                280.2,
                -14.45
              ],
              [
                -527.75,
                82.5
              ],
              [
                254.2,
                -36.45
              ],
              [
                280.2,
                -36.45
              ]
            ]
          ]
        },
        {
          "name": "potolok",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                257,
                -78
              ],
              [
                257,
                -19
              ],
              [
                -200,
                44
              ],
              [
                -257,
                -10
              ],
              [
                -257,
                -78
              ]
            ],
            [
              [
                -200,
                44
              ],
              [
                257,
                -19
              ],
              [
                205,
                33
              ],
              [
                -200,
                78
              ]
            ],
            [
              [
                205,
                78
              ],
              [
                -200,
                78
              ],
              [
                205,
                33
              ]
            ]
          ]
        },
        {
          "name": "triangle",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -375.95,
                -58
              ],
              [
                -155.95,
                -36.75
              ],
              [
                257.1,
                31.15
              ],
              [
                -373.9,
                55
              ]
            ],
            [
              [
                404,
                55
              ],
              [
                -373.9,
                55
              ],
              [
                257.1,
                31.15
              ],
              [
                404,
                31.2
              ]
            ],
            [
              [
                257.1,
                31.15
              ],
              [
                -155.95,
                -36.75
              ],
              [
                112.1,
                -53.75
              ]
            ],
            [
              [
                112.1,
                -53.75
              ],
              [
                -155.95,
                -36.75
              ],
              [
                -0.4,
                -126.95
              ]
            ]
          ]
        },
        {
          "name": "movePlatform1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                75,
                -5
              ],
              [
                75,
                5
              ],
              [
                -75,
                5
              ],
              [
                -75,
                -5
              ]
            ]
          ]
        },
        {
          "name": "movePlatform2",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                75,
                -5
              ],
              [
                75,
                5
              ],
              [
                -75,
                5
              ],
              [
                -75,
                -5
              ]
            ]
          ]
        },
        {
          "name": "jumpPlatform2",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "vanna",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                415.5,
                -92.5
              ],
              [
                415.5,
                -59.05
              ],
              [
                194.55,
                92.45
              ],
              [
                164.55,
                50.45
              ],
              [
                234.55,
                -92.5
              ]
            ],
            [
              [
                -156.45,
                -89.5
              ],
              [
                -63.45,
                50.45
              ],
              [
                -74.45,
                92.45
              ],
              [
                -415.45,
                -59.55
              ],
              [
                -415.45,
                -89.5
              ]
            ],
            [
              [
                -63.45,
                50.45
              ],
              [
                164.55,
                50.45
              ],
              [
                194.55,
                92.45
              ],
              [
                -74.45,
                92.45
              ]
            ]
          ]
        },
        {
          "name": "redWall",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                1.5,
                -61.5
              ],
              [
                1.5,
                61.5
              ],
              [
                -18.5,
                61.5
              ],
              [
                -18.5,
                -61.5
              ]
            ]
          ]
        },
        {
          "name": "bigMovePlatform",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -75,
                -5
              ],
              [
                75,
                -5
              ],
              [
                75,
                5
              ],
              [
                -75,
                5
              ]
            ]
          ]
        },
        {
          "name": "endPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                150,
                0
              ],
              [
                150,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "\"box\" + _loc3_.toString()",
          "shape": "Polygon",
          "density": 0.3,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                10,
                -10
              ],
              [
                10,
                10
              ],
              [
                -10,
                10
              ],
              [
                -10,
                -10
              ]
            ]
          ]
        },
        {
          "name": "bluePlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                140,
                0
              ],
              [
                140,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "star",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -0.25,
                15
              ],
              [
                2,
                27.85
              ],
              [
                -2.15,
                27.95
              ]
            ],
            [
              [
                2,
                27.85
              ],
              [
                15,
                29.75
              ],
              [
                2.1,
                32
              ],
              [
                -2.05,
                32.1
              ],
              [
                -15,
                30.2
              ],
              [
                -2.15,
                27.95
              ]
            ],
            [
              [
                0.2,
                45
              ],
              [
                -2.05,
                32.1
              ],
              [
                2.1,
                32
              ]
            ]
          ]
        }
      ]
    },
    {
      "id": 8,
      "className": "Levels.Level_8",
      "symbolId": 389,
      "svgPath": "port/generated/levels/level_8/1.svg",
      "imagePath": "port/generated/levels_png/level_8/1.png",
      "foregroundSvgPath": null,
      "layout": {
        "imageWidth": 5717.85,
        "imageHeight": 2186.2,
        "imageOffsetX": -1921.05,
        "imageOffsetY": -468.65,
        "namedChildren": {
          "backGroundMC": {
            "x": 40.4,
            "y": 148.0,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "levelAim": {
            "x": 2736.55,
            "y": 1436.25,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "firstRampa": {
            "x": -1667.9,
            "y": -16.0,
            "width": 973.1,
            "height": 983.8,
            "rotation": 0.0
          },
          "pol": {
            "x": -734.0,
            "y": 289.95,
            "width": 747.4,
            "height": 300.5,
            "rotation": 0.0
          },
          "potolok1": {
            "x": -734.0,
            "y": -5.0,
            "width": 536.2,
            "height": 582.9,
            "rotation": 0.0
          },
          "shipik3": {
            "x": -733.6,
            "y": 355.55,
            "width": 66.0,
            "height": 9.65,
            "rotation": -90.0
          },
          "shipik2": {
            "x": -733.6,
            "y": 421.55,
            "width": 66.0,
            "height": 9.65,
            "rotation": -90.0
          },
          "shipik1": {
            "x": -733.6,
            "y": 487.55,
            "width": 66.0,
            "height": 9.65,
            "rotation": -90.0
          },
          "shipik4": {
            "x": -733.3,
            "y": 195.25,
            "width": 66.0,
            "height": 9.65,
            "rotation": -90.0
          },
          "shipik5": {
            "x": -733.3,
            "y": 129.25,
            "width": 66.0,
            "height": 9.65,
            "rotation": -90.0
          },
          "shipik6": {
            "x": -733.3,
            "y": 63.25,
            "width": 66.0,
            "height": 9.65,
            "rotation": -90.0
          },
          "koleco1": {
            "x": -171.0,
            "y": 265.45,
            "width": 24.3,
            "height": 24.3,
            "rotation": 0.0
          },
          "koleco2": {
            "x": -113.0,
            "y": 265.45,
            "width": 24.3,
            "height": 24.3,
            "rotation": 0.0
          },
          "car": {
            "x": -179.0,
            "y": 234.85,
            "width": 99.0,
            "height": 42.75,
            "rotation": 0.0
          },
          "killSpusk": {
            "x": -50.0,
            "y": 290.0,
            "width": 964.95,
            "height": 548.95,
            "rotation": 0.0
          },
          "killSpusk2": {
            "x": 2204.25,
            "y": 1453.8,
            "width": 1064.95,
            "height": 524.95,
            "rotation": -179.50623158092043
          },
          "potolok2": {
            "x": -506.0,
            "y": -4.95,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "killer1": {
            "x": -543.0,
            "y": -5.0,
            "width": 181.6,
            "height": 393.4,
            "rotation": 0.0
          },
          "killer2": {
            "x": -468.0,
            "y": 70.0,
            "width": 181.6,
            "height": 393.4,
            "rotation": 0.0
          },
          "potolok3": {
            "x": -431.0,
            "y": -4.95,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "killer3": {
            "x": -393.0,
            "y": -5.0,
            "width": 181.6,
            "height": 393.4,
            "rotation": 0.0
          },
          "potolok4": {
            "x": -356.0,
            "y": -5.0,
            "width": 584.25,
            "height": 527.65,
            "rotation": 0.0
          },
          "finishPlatform": {
            "x": 2305.25,
            "y": 1467.45,
            "width": 579.05,
            "height": 300.5,
            "rotation": 0.0
          },
          "shipik7": {
            "x": 2378.45,
            "y": 1467.2,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "shipik8": {
            "x": 2444.45,
            "y": 1467.2,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "shipik9": {
            "x": 2510.45,
            "y": 1467.2,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "shipik10": {
            "x": 2576.45,
            "y": 1467.2,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "shipik11": {
            "x": 2642.95,
            "y": 1467.2,
            "width": 66.0,
            "height": 9.65,
            "rotation": 0.0
          },
          "barier": {
            "x": -648.45,
            "y": 256.25,
            "width": 118.75,
            "height": 88.3,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": -1641.0,
            "y": -34.65,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint1": {
            "x": -271.1,
            "y": 269.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5748,
        "sourceHeight": 2217,
        "cropX": 161,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2201
      },
      "symbols": {},
      "bodies": [
        {
          "name": "firstRampa",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                217,
                189
              ],
              [
                247,
                270
              ],
              [
                84,
                4
              ],
              [
                102,
                11
              ],
              [
                115,
                24
              ],
              [
                127,
                37
              ],
              [
                145,
                60
              ],
              [
                174,
                100
              ],
              [
                197,
                143
              ]
            ],
            [
              [
                247,
                270
              ],
              [
                288,
                338.95
              ],
              [
                0,
                480.95
              ],
              [
                0,
                0
              ],
              [
                68,
                0
              ],
              [
                84,
                4
              ]
            ],
            [
              [
                288,
                338.95
              ],
              [
                315.95,
                365.95
              ],
              [
                0,
                480.95
              ]
            ],
            [
              [
                315.95,
                365.95
              ],
              [
                348.95,
                380.95
              ],
              [
                0,
                480.95
              ]
            ],
            [
              [
                348.95,
                380.95
              ],
              [
                390.95,
                386.95
              ],
              [
                478.95,
                480.95
              ],
              [
                0,
                480.95
              ]
            ],
            [
              [
                478.95,
                354.95
              ],
              [
                478.95,
                480.95
              ],
              [
                428.95,
                378.95
              ]
            ],
            [
              [
                428.95,
                378.95
              ],
              [
                478.95,
                480.95
              ],
              [
                390.95,
                386.95
              ]
            ]
          ]
        },
        {
          "name": "pol",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                683,
                0
              ],
              [
                683,
                34.05
              ],
              [
                500,
                34.05
              ],
              [
                0,
                0
              ]
            ],
            [
              [
                0,
                200.05
              ],
              [
                0,
                0
              ],
              [
                500,
                34.05
              ],
              [
                500,
                200.05
              ]
            ]
          ]
        },
        {
          "name": "potolok1",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                198,
                0
              ],
              [
                198,
                200.05
              ],
              [
                0,
                200.05
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "potolok2",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                0,
                0
              ],
              [
                45,
                0
              ],
              [
                45,
                200
              ],
              [
                0,
                200
              ]
            ]
          ]
        },
        {
          "name": "potolok3",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                0,
                0
              ],
              [
                45,
                0
              ],
              [
                45,
                200
              ],
              [
                0,
                200
              ]
            ]
          ]
        },
        {
          "name": "potolok4",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                0,
                0
              ],
              [
                125,
                0
              ],
              [
                125,
                200
              ],
              [
                0,
                200
              ]
            ]
          ]
        },
        {
          "name": "killSpusk",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                954.95,
                494.95
              ],
              [
                963.95,
                524.95
              ],
              [
                874.95,
                514.95
              ]
            ],
            [
              [
                874.95,
                514.95
              ],
              [
                963.95,
                524.95
              ],
              [
                882.95,
                547.95
              ],
              [
                792.95,
                547.95
              ],
              [
                798.95,
                514.95
              ]
            ],
            [
              [
                182.95,
                26
              ],
              [
                544.95,
                393.95
              ],
              [
                522.95,
                419.95
              ],
              [
                164,
                53.95
              ],
              [
                115.95,
                0
              ]
            ],
            [
              [
                0,
                0
              ],
              [
                115.95,
                0
              ],
              [
                111,
                33.95
              ],
              [
                0,
                33.95
              ]
            ],
            [
              [
                111,
                33.95
              ],
              [
                115.95,
                0
              ],
              [
                164,
                53.95
              ]
            ],
            [
              [
                544.95,
                393.95
              ],
              [
                646.95,
                458.95
              ],
              [
                522.95,
                419.95
              ]
            ],
            [
              [
                646.95,
                458.95
              ],
              [
                798.95,
                514.95
              ],
              [
                792.95,
                547.95
              ],
              [
                632.95,
                491
              ],
              [
                522.95,
                419.95
              ]
            ]
          ]
        },
        {
          "name": "car",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                98,
                40.75
              ],
              [
                91.5,
                41.75
              ],
              [
                91.5,
                39.25
              ],
              [
                98,
                24.25
              ]
            ],
            [
              [
                62,
                0
              ],
              [
                68,
                16.5
              ],
              [
                65.75,
                17
              ],
              [
                59.75,
                0
              ]
            ],
            [
              [
                68,
                16.5
              ],
              [
                98,
                24.25
              ],
              [
                65.75,
                26
              ],
              [
                65.75,
                17
              ]
            ],
            [
              [
                17.25,
                0.5
              ],
              [
                20.5,
                21.75
              ],
              [
                13.5,
                28.5
              ],
              [
                9.5,
                31.5
              ],
              [
                0,
                0.5
              ]
            ],
            [
              [
                0,
                41.5
              ],
              [
                0,
                0.5
              ],
              [
                6.5,
                36.25
              ],
              [
                5.5,
                41.5
              ]
            ],
            [
              [
                6.5,
                36.25
              ],
              [
                0,
                0.5
              ],
              [
                9.5,
                31.5
              ]
            ],
            [
              [
                13.5,
                28.5
              ],
              [
                20.5,
                21.75
              ],
              [
                17.25,
                27.5
              ]
            ],
            [
              [
                20.5,
                21.75
              ],
              [
                33.25,
                26
              ],
              [
                17.25,
                27.5
              ]
            ],
            [
              [
                33.25,
                26
              ],
              [
                65.75,
                26
              ],
              [
                21.25,
                27.5
              ],
              [
                17.25,
                27.5
              ]
            ],
            [
              [
                21.25,
                27.5
              ],
              [
                65.75,
                26
              ],
              [
                25.5,
                28.5
              ]
            ],
            [
              [
                65.75,
                26
              ],
              [
                98,
                24.25
              ],
              [
                28.5,
                30.25
              ],
              [
                25.5,
                28.5
              ]
            ],
            [
              [
                28.5,
                30.25
              ],
              [
                98,
                24.25
              ],
              [
                75.25,
                27.5
              ],
              [
                30.75,
                32.75
              ]
            ],
            [
              [
                33.75,
                41.5
              ],
              [
                33.5,
                39.25
              ],
              [
                63.5,
                41.5
              ]
            ],
            [
              [
                33.5,
                39.25
              ],
              [
                32.25,
                35.5
              ],
              [
                63.5,
                41.5
              ]
            ],
            [
              [
                32.25,
                35.5
              ],
              [
                30.75,
                32.75
              ],
              [
                64.5,
                36.25
              ],
              [
                63.5,
                41.5
              ]
            ],
            [
              [
                64.5,
                36.25
              ],
              [
                30.75,
                32.75
              ],
              [
                67.5,
                31.5
              ]
            ],
            [
              [
                67.5,
                31.5
              ],
              [
                30.75,
                32.75
              ],
              [
                71.5,
                28.5
              ]
            ],
            [
              [
                71.5,
                28.5
              ],
              [
                30.75,
                32.75
              ],
              [
                75.25,
                27.5
              ]
            ],
            [
              [
                75.25,
                27.5
              ],
              [
                98,
                24.25
              ],
              [
                79.25,
                27.5
              ]
            ],
            [
              [
                79.25,
                27.5
              ],
              [
                98,
                24.25
              ],
              [
                83.5,
                28.5
              ]
            ],
            [
              [
                83.5,
                28.5
              ],
              [
                98,
                24.25
              ],
              [
                86.5,
                30.25
              ]
            ],
            [
              [
                86.5,
                30.25
              ],
              [
                98,
                24.25
              ],
              [
                88.75,
                32.75
              ]
            ],
            [
              [
                88.75,
                32.75
              ],
              [
                98,
                24.25
              ],
              [
                90.25,
                35.5
              ]
            ],
            [
              [
                90.25,
                35.5
              ],
              [
                98,
                24.25
              ],
              [
                91.5,
                39.25
              ]
            ]
          ]
        },
        {
          "name": "killSpusk2",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                290,
                76
              ],
              [
                631.05,
                409.05
              ],
              [
                275,
                105.95
              ],
              [
                199,
                34
              ]
            ],
            [
              [
                0,
                0
              ],
              [
                199,
                34
              ],
              [
                191,
                65.95
              ],
              [
                -6,
                34.95
              ]
            ],
            [
              [
                191,
                65.95
              ],
              [
                199,
                34
              ],
              [
                275,
                105.95
              ]
            ],
            [
              [
                275,
                105.95
              ],
              [
                631.05,
                409.05
              ],
              [
                618,
                439.95
              ]
            ],
            [
              [
                631.05,
                409.05
              ],
              [
                717.05,
                457.05
              ],
              [
                618,
                439.95
              ]
            ],
            [
              [
                717.05,
                457.05
              ],
              [
                891.05,
                494.05
              ],
              [
                882.95,
                523.95
              ],
              [
                705.95,
                485.95
              ],
              [
                618,
                439.95
              ]
            ],
            [
              [
                891.05,
                494.05
              ],
              [
                965.05,
                494.05
              ],
              [
                964.95,
                523.95
              ],
              [
                882.95,
                523.95
              ]
            ],
            [
              [
                964.95,
                523.95
              ],
              [
                965.05,
                494.05
              ],
              [
                1049.05,
                468.05
              ],
              [
                1057.95,
                493.95
              ]
            ]
          ]
        },
        {
          "name": "koleco1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            23.3
          ]
        },
        {
          "name": "koleco2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            23.3
          ]
        },
        {
          "name": "killer1",
          "shape": "Polygon",
          "density": 10.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                8.9,
                0
              ],
              [
                34.9,
                0
              ],
              [
                34.9,
                200
              ],
              [
                22.2,
                218.5
              ],
              [
                8.9,
                200
              ]
            ]
          ]
        },
        {
          "name": "killer2",
          "shape": "Polygon",
          "density": 10.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                8.9,
                0
              ],
              [
                34.9,
                0
              ],
              [
                34.9,
                200
              ],
              [
                22.2,
                218.5
              ],
              [
                8.9,
                200
              ]
            ]
          ]
        },
        {
          "name": "killer3",
          "shape": "Polygon",
          "density": 10.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                8.9,
                0
              ],
              [
                34.9,
                0
              ],
              [
                34.9,
                200
              ],
              [
                22.2,
                218.5
              ],
              [
                8.9,
                200
              ]
            ]
          ]
        },
        {
          "name": "finishPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                482.85,
                -107
              ],
              [
                500.05,
                -107
              ],
              [
                500.05,
                20
              ],
              [
                482.85,
                0
              ]
            ],
            [
              [
                0,
                0
              ],
              [
                482.85,
                0
              ],
              [
                500.05,
                20
              ],
              [
                0,
                20
              ]
            ]
          ]
        },
        {
          "name": "barier",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                24.75,
                0
              ],
              [
                34.5,
                33.75
              ],
              [
                0,
                33.75
              ],
              [
                10,
                0
              ]
            ]
          ]
        }
      ]
    },
    {
      "id": 9,
      "className": "Levels.Level_9",
      "symbolId": 248,
      "svgPath": "port/generated/levels/level_9/1.svg",
      "imagePath": "port/generated/levels_png/level_9/1.png",
      "foregroundSvgPath": null,
      "layout": {
        "imageWidth": 5564.9,
        "imageHeight": 2186.2,
        "imageOffsetX": -2148.5,
        "imageOffsetY": -1314.65,
        "namedChildren": {
          "backGroundMC": {
            "x": -340.0,
            "y": -698.0,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "levelAim": {
            "x": 2939.85,
            "y": 87.7,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "firstCrank": {
            "x": 1632.85,
            "y": 5.3,
            "width": 366.3,
            "height": 366.3,
            "rotation": 66.77431501508343
          },
          "secondCrank": {
            "x": 1606.05,
            "y": -55.9,
            "width": 402.75,
            "height": 231.65,
            "rotation": -25.73462426963923
          },
          "boomCrank": {
            "x": 1480.15,
            "y": 4.8,
            "width": 70.25,
            "height": 31.0,
            "rotation": 0.0
          },
          "firstBigPlatform": {
            "x": -1346.9,
            "y": -286.95,
            "width": 1488.35,
            "height": 922.2,
            "rotation": 0.0
          },
          "greenCheck1": {
            "x": 79.5,
            "y": 75.0,
            "width": 11.0,
            "height": 11.0,
            "rotation": 0.0
          },
          "greenCheck2": {
            "x": 218.5,
            "y": 75.0,
            "width": 11.0,
            "height": 11.0,
            "rotation": 0.0
          },
          "greenCheck3": {
            "x": 350.5,
            "y": 75.0,
            "width": 11.0,
            "height": 11.0,
            "rotation": 0.0
          },
          "greenPlatform": {
            "x": 401.0,
            "y": 96.95,
            "width": 210.4,
            "height": 116.3,
            "rotation": 0.0
          },
          "lowPlatform": {
            "x": 1256.9,
            "y": 129.95,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "upPlatform": {
            "x": 1415.9,
            "y": -71.0,
            "width": 563.05,
            "height": 418.45,
            "rotation": 0.0
          },
          "middlePlatform": {
            "x": 1492.9,
            "y": 103.05,
            "width": 585.75,
            "height": 511.65,
            "rotation": 0.0
          },
          "jumpBall1": {
            "x": 2216.05,
            "y": 57.25,
            "width": 191.65,
            "height": 191.65,
            "rotation": 0.0
          },
          "jumpBall2": {
            "x": 2315.1,
            "y": 57.25,
            "width": 191.65,
            "height": 191.65,
            "rotation": 0.0
          },
          "jumpBall3": {
            "x": 2741.05,
            "y": 57.25,
            "width": 191.65,
            "height": 191.65,
            "rotation": 0.0
          },
          "finishPlatform": {
            "x": 2930.7,
            "y": 131.1,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "bridgeElement1": {
            "x": 731.25,
            "y": 25.0,
            "width": 193.15,
            "height": 138.75,
            "rotation": 0.0
          },
          "bridgeElement2": {
            "x": 783.25,
            "y": 25.0,
            "width": 193.15,
            "height": 138.75,
            "rotation": 0.0
          },
          "bridgeElement3": {
            "x": 836.0,
            "y": 25.0,
            "width": 193.15,
            "height": 138.75,
            "rotation": 0.0
          },
          "bridgeElement4": {
            "x": 889.75,
            "y": 25.0,
            "width": 193.15,
            "height": 138.75,
            "rotation": 0.0
          },
          "bridgeElement5": {
            "x": 941.75,
            "y": 25.0,
            "width": 193.15,
            "height": 138.75,
            "rotation": 0.0
          },
          "bridgeElement6": {
            "x": 994.5,
            "y": 25.0,
            "width": 193.15,
            "height": 138.75,
            "rotation": 0.0
          },
          "bridgeElement7": {
            "x": 1048.75,
            "y": 25.0,
            "width": 193.15,
            "height": 138.75,
            "rotation": 0.0
          },
          "bridgeElement8": {
            "x": 1100.75,
            "y": 25.0,
            "width": 193.15,
            "height": 138.75,
            "rotation": 0.0
          },
          "bridgeElement9": {
            "x": 1153.5,
            "y": 25.0,
            "width": 193.15,
            "height": 138.75,
            "rotation": 0.0
          },
          "bridgeElement10": {
            "x": 1207.0,
            "y": 25.0,
            "width": 193.15,
            "height": 138.75,
            "rotation": 0.0
          },
          "low2Platform": {
            "x": 1651.55,
            "y": 133.95,
            "width": 955.8,
            "height": 300.5,
            "rotation": 0.0
          },
          "killRollBall": {
            "x": 972.4,
            "y": -30.5,
            "width": 51.0,
            "height": 51.05,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": -1307.0,
            "y": -302.6,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint1": {
            "x": -112.1,
            "y": 72.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint2": {
            "x": 1273.8,
            "y": 1.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint3": {
            "x": 1987.8,
            "y": 103.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5595,
        "sourceHeight": 2217,
        "cropX": 8,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2201
      },
      "symbols": {},
      "bodies": [
        {
          "name": "firstCrank",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                6.8,
                -7.65
              ],
              [
                6.8,
                7.35
              ],
              [
                -73.2,
                7.35
              ],
              [
                -73.2,
                -7.65
              ]
            ]
          ]
        },
        {
          "name": "secondCrank",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                7.2,
                -6.6
              ],
              [
                7.2,
                8.4
              ],
              [
                -142.8,
                8.4
              ],
              [
                -142.8,
                -6.6
              ]
            ]
          ]
        },
        {
          "name": "boomCrank",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                5,
                -15
              ],
              [
                5,
                15
              ],
              [
                -53.5,
                15
              ],
              [
                -64.25,
                -0.25
              ],
              [
                -53.5,
                -15
              ]
            ]
          ]
        },
        {
          "name": "firstBigPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                1327.45,
                378.95
              ],
              [
                1327.45,
                400.95
              ],
              [
                0,
                400.95
              ],
              [
                1121.45,
                378.95
              ]
            ],
            [
              [
                1121.45,
                361.95
              ],
              [
                1121.45,
                378.95
              ],
              [
                1103.9,
                361.9
              ]
            ],
            [
              [
                1103.9,
                342.9
              ],
              [
                1103.9,
                361.9
              ],
              [
                1085.9,
                342.9
              ]
            ],
            [
              [
                1085.9,
                323.95
              ],
              [
                1085.9,
                342.9
              ],
              [
                1067.9,
                323.95
              ]
            ],
            [
              [
                1085.9,
                342.9
              ],
              [
                1103.9,
                361.9
              ],
              [
                953.4,
                251.95
              ],
              [
                1067.9,
                323.95
              ]
            ],
            [
              [
                1067.9,
                304.95
              ],
              [
                1067.9,
                323.95
              ],
              [
                1049.9,
                304.95
              ]
            ],
            [
              [
                1049.9,
                281.95
              ],
              [
                1049.9,
                304.95
              ],
              [
                1029.05,
                281.95
              ]
            ],
            [
              [
                1029.05,
                281.95
              ],
              [
                1049.9,
                304.95
              ],
              [
                953.4,
                251.95
              ],
              [
                1001.6,
                251.95
              ]
            ],
            [
              [
                1049.9,
                304.95
              ],
              [
                1067.9,
                323.95
              ],
              [
                953.4,
                251.95
              ]
            ],
            [
              [
                1103.9,
                361.9
              ],
              [
                1121.45,
                378.95
              ],
              [
                953.4,
                281.95
              ],
              [
                953.4,
                251.95
              ]
            ],
            [
              [
                953.4,
                281.95
              ],
              [
                1121.45,
                378.95
              ],
              [
                896.9,
                281.95
              ]
            ],
            [
              [
                896.9,
                281.95
              ],
              [
                1121.45,
                378.95
              ],
              [
                850.9,
                280.95
              ]
            ],
            [
              [
                850.9,
                280.95
              ],
              [
                1121.45,
                378.95
              ],
              [
                800.9,
                273.95
              ]
            ],
            [
              [
                800.9,
                273.95
              ],
              [
                1121.45,
                378.95
              ],
              [
                0,
                400.95
              ],
              [
                777.95,
                266.95
              ]
            ],
            [
              [
                441.95,
                57
              ],
              [
                458.95,
                117
              ],
              [
                190,
                46
              ]
            ],
            [
              [
                458.95,
                117
              ],
              [
                755.95,
                257.95
              ],
              [
                190,
                46
              ]
            ],
            [
              [
                755.95,
                257.95
              ],
              [
                777.95,
                266.95
              ],
              [
                0,
                400.95
              ],
              [
                0,
                0
              ],
              [
                190,
                46
              ]
            ],
            [
              [
                196,
                20
              ],
              [
                190,
                46
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "greenPlatform",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                49,
                -5
              ],
              [
                49,
                5
              ],
              [
                -49,
                5
              ],
              [
                -49,
                -5
              ]
            ]
          ]
        },
        {
          "name": "lowPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -581.95,
                -109.1
              ],
              [
                -522.95,
                -109.1
              ],
              [
                -522.95,
                -9
              ],
              [
                -705.95,
                -35
              ]
            ],
            [
              [
                -795.95,
                -35
              ],
              [
                -705.95,
                -35
              ],
              [
                -522.95,
                -9
              ],
              [
                -795.95,
                -9
              ]
            ]
          ]
        },
        {
          "name": "low2Platform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                286.95,
                -10.95
              ],
              [
                399.95,
                -10.95
              ],
              [
                286.95,
                14.05
              ]
            ],
            [
              [
                262.95,
                14.05
              ],
              [
                286.95,
                14.05
              ],
              [
                262.95,
                37.05
              ]
            ],
            [
              [
                286.95,
                14.05
              ],
              [
                399.95,
                -10.95
              ],
              [
                262.95,
                37.05
              ]
            ],
            [
              [
                239.95,
                37.05
              ],
              [
                262.95,
                37.05
              ],
              [
                239.95,
                59.05
              ]
            ],
            [
              [
                262.95,
                37.05
              ],
              [
                399.95,
                -10.95
              ],
              [
                239.95,
                59.05
              ]
            ],
            [
              [
                215,
                59.05
              ],
              [
                239.95,
                59.05
              ],
              [
                215,
                82
              ]
            ],
            [
              [
                239.95,
                59.05
              ],
              [
                399.95,
                -10.95
              ],
              [
                399.95,
                113
              ],
              [
                215,
                82
              ]
            ],
            [
              [
                -399.95,
                -112.95
              ],
              [
                -288,
                -112.95
              ],
              [
                -318,
                -13
              ],
              [
                -399.95,
                -13
              ]
            ],
            [
              [
                -288,
                -112.95
              ],
              [
                -288,
                82
              ],
              [
                -318,
                113
              ],
              [
                -318,
                -13
              ]
            ],
            [
              [
                -288,
                82
              ],
              [
                215,
                82
              ],
              [
                399.95,
                113
              ],
              [
                -318,
                113
              ]
            ]
          ]
        },
        {
          "name": "upPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                163,
                -58
              ],
              [
                163,
                -26
              ],
              [
                29,
                1.5
              ],
              [
                -162.95,
                -58
              ]
            ],
            [
              [
                -162.95,
                47
              ],
              [
                -162.95,
                -58
              ],
              [
                29,
                1.5
              ],
              [
                29,
                58
              ],
              [
                -150.95,
                58
              ]
            ]
          ]
        },
        {
          "name": "middlePlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -48.6,
                -81.9
              ],
              [
                -48.6,
                -26.05
              ],
              [
                -96,
                81.9
              ],
              [
                -96,
                -81.9
              ]
            ],
            [
              [
                -96,
                81.9
              ],
              [
                -48.6,
                -26.05
              ],
              [
                96,
                -9.05
              ],
              [
                96,
                81.9
              ]
            ]
          ]
        },
        {
          "name": "finishPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -58,
                -12.5
              ],
              [
                58,
                -12.5
              ],
              [
                58,
                12.5
              ],
              [
                -58,
                12.5
              ]
            ]
          ]
        },
        {
          "name": "bridgeElement1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -4,
                -4
              ],
              [
                56,
                -4
              ],
              [
                56,
                4
              ],
              [
                -4,
                4
              ]
            ]
          ]
        },
        {
          "name": "bridgeElement2",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -4,
                -4
              ],
              [
                56,
                -4
              ],
              [
                56,
                4
              ],
              [
                -4,
                4
              ]
            ]
          ]
        },
        {
          "name": "bridgeElement3",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -4,
                -4
              ],
              [
                56,
                -4
              ],
              [
                56,
                4
              ],
              [
                -4,
                4
              ]
            ]
          ]
        },
        {
          "name": "bridgeElement4",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -4,
                -4
              ],
              [
                56,
                -4
              ],
              [
                56,
                4
              ],
              [
                -4,
                4
              ]
            ]
          ]
        },
        {
          "name": "bridgeElement5",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -4,
                -4
              ],
              [
                56,
                -4
              ],
              [
                56,
                4
              ],
              [
                -4,
                4
              ]
            ]
          ]
        },
        {
          "name": "bridgeElement6",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -4,
                -4
              ],
              [
                56,
                -4
              ],
              [
                56,
                4
              ],
              [
                -4,
                4
              ]
            ]
          ]
        },
        {
          "name": "bridgeElement7",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -4,
                -4
              ],
              [
                56,
                -4
              ],
              [
                56,
                4
              ],
              [
                -4,
                4
              ]
            ]
          ]
        },
        {
          "name": "bridgeElement8",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -4,
                -4
              ],
              [
                56,
                -4
              ],
              [
                56,
                4
              ],
              [
                -4,
                4
              ]
            ]
          ]
        },
        {
          "name": "bridgeElement9",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -4,
                -4
              ],
              [
                56,
                -4
              ],
              [
                56,
                4
              ],
              [
                -4,
                4
              ]
            ]
          ]
        },
        {
          "name": "bridgeElement10",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -4,
                -4
              ],
              [
                56,
                -4
              ],
              [
                56,
                4
              ],
              [
                -4,
                4
              ]
            ]
          ]
        },
        {
          "name": "killRollBall",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            50
          ]
        },
        {
          "name": "jumpBall1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            75
          ]
        },
        {
          "name": "jumpBall2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            75
          ]
        },
        {
          "name": "jumpBall3",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            75
          ]
        }
      ]
    },
    {
      "id": 10,
      "className": "Levels.Level_10",
      "symbolId": 205,
      "svgPath": "port/generated/levels/level_10/1.svg",
      "imagePath": "port/generated/levels_png/level_10/1.png",
      "foregroundSvgPath": null,
      "layout": {
        "imageWidth": 5587.5,
        "imageHeight": 2186.2,
        "imageOffsetX": -1935.0,
        "imageOffsetY": -1466.75,
        "namedChildren": {
          "backGroundMC": {
            "x": -103.9,
            "y": -850.1,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "levelAim": {
            "x": 1926.85,
            "y": -318.6,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "firstPlatform": {
            "x": -1735.9,
            "y": -23.95,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "barierPlatform": {
            "x": -1555.0,
            "y": -23.95,
            "width": 649.15,
            "height": 300.5,
            "rotation": 0.0
          },
          "firstBarier": {
            "x": -1488.9,
            "y": -54.0,
            "width": 166.35,
            "height": 112.3,
            "rotation": 0.0
          },
          "secondBarier": {
            "x": -1335.9,
            "y": -74.0,
            "width": 183.2,
            "height": 146.4,
            "rotation": 0.0
          },
          "thirdBarier": {
            "x": -1183.45,
            "y": -94.0,
            "width": 205.3,
            "height": 158.5,
            "rotation": 0.0
          },
          "jumpPlatform1": {
            "x": -867.6,
            "y": -23.65,
            "width": 428.1,
            "height": 309.15,
            "rotation": 0.0
          },
          "jumpPlatform2": {
            "x": -725.7,
            "y": -164.65,
            "width": 428.1,
            "height": 309.15,
            "rotation": 0.0
          },
          "jumpPlatform3": {
            "x": -585.65,
            "y": -303.65,
            "width": 428.1,
            "height": 309.15,
            "rotation": 0.0
          },
          "forthBarier": {
            "x": -1034.5,
            "y": -114.0,
            "width": 205.3,
            "height": 158.5,
            "rotation": 0.0
          },
          "afterJump": {
            "x": -55.7,
            "y": -426.95,
            "width": 502.95,
            "height": 300.5,
            "rotation": -179.85089711695178
          },
          "cube1": {
            "x": 79.15,
            "y": -437.0,
            "width": 294.15,
            "height": 294.15,
            "rotation": 0.0
          },
          "cube2": {
            "x": 251.1,
            "y": -437.0,
            "width": 294.15,
            "height": 294.15,
            "rotation": 0.0
          },
          "cube3": {
            "x": 425.1,
            "y": -437.0,
            "width": 294.15,
            "height": 294.15,
            "rotation": 0.0
          },
          "mainRampa": {
            "x": 576.05,
            "y": -488.0,
            "width": 1440.25,
            "height": 689.5,
            "rotation": 0.0
          },
          "goBall": {
            "x": 1015.0,
            "y": -368.0,
            "width": 408.55,
            "height": 233.2,
            "rotation": 0.0
          },
          "roundBlock": {
            "x": -737.45,
            "y": -252.75,
            "width": 128.3,
            "height": 33.0,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": -1687.0,
            "y": -43.65,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint1": {
            "x": -972.05,
            "y": -44.65,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint2": {
            "x": -99.1,
            "y": -467.6,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint3": {
            "x": 900.8,
            "y": -307.15,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5618,
        "sourceHeight": 2217,
        "cropX": 30,
        "cropY": 8,
        "cropWidth": 5579,
        "cropHeight": 2201
      },
      "symbols": {},
      "bodies": [
        {
          "name": "firstPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                112,
                0
              ],
              [
                112,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "barierPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                610,
                0
              ],
              [
                610,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "firstBarier",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                23.5,
                0
              ],
              [
                20,
                3.55
              ],
              [
                0,
                3.55
              ],
              [
                -3.75,
                0
              ]
            ],
            [
              [
                0,
                3.55
              ],
              [
                20,
                3.55
              ],
              [
                20,
                30
              ],
              [
                0,
                30
              ]
            ]
          ]
        },
        {
          "name": "secondBarier",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                23.5,
                0
              ],
              [
                20,
                4
              ],
              [
                0,
                3.75
              ],
              [
                -3.5,
                0
              ]
            ],
            [
              [
                0,
                3.75
              ],
              [
                20,
                4
              ],
              [
                20,
                50
              ],
              [
                0,
                50
              ]
            ]
          ]
        },
        {
          "name": "thirdBarier",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                23.5,
                0
              ],
              [
                20,
                3.75
              ],
              [
                0,
                4
              ],
              [
                -3.75,
                0
              ]
            ],
            [
              [
                0,
                4
              ],
              [
                20,
                3.75
              ],
              [
                20,
                70
              ],
              [
                0,
                70
              ]
            ]
          ]
        },
        {
          "name": "forthBarier",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                27.25,
                0
              ],
              [
                23.75,
                4.8
              ],
              [
                3.75,
                5.15
              ],
              [
                0,
                0
              ]
            ],
            [
              [
                3.75,
                5.15
              ],
              [
                23.75,
                4.8
              ],
              [
                23.75,
                90
              ],
              [
                3.75,
                90
              ]
            ]
          ]
        },
        {
          "name": "jumpPlatform1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "jumpPlatform2",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "jumpPlatform3",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "afterJump",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                301.45,
                -0.25
              ],
              [
                372.45,
                -0.25
              ],
              [
                301.45,
                20.25
              ],
              [
                232.95,
                30
              ]
            ],
            [
              [
                71,
                0
              ],
              [
                138.95,
                30
              ],
              [
                71,
                20.5
              ],
              [
                0,
                0
              ]
            ],
            [
              [
                0,
                20.5
              ],
              [
                0,
                0
              ],
              [
                71,
                20.5
              ]
            ],
            [
              [
                71,
                20.5
              ],
              [
                138.95,
                30
              ],
              [
                139.45,
                50
              ]
            ],
            [
              [
                138.95,
                30
              ],
              [
                232.95,
                30
              ],
              [
                232.95,
                50
              ],
              [
                139.45,
                50
              ]
            ],
            [
              [
                232.95,
                50
              ],
              [
                232.95,
                30
              ],
              [
                301.45,
                20.25
              ]
            ],
            [
              [
                372.45,
                20.25
              ],
              [
                301.45,
                20.25
              ],
              [
                372.45,
                -0.25
              ]
            ]
          ]
        },
        {
          "name": "cube1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -50,
                50
              ],
              [
                -50,
                -50
              ],
              [
                50,
                -50
              ],
              [
                50,
                50
              ]
            ]
          ]
        },
        {
          "name": "cube2",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -50,
                50
              ],
              [
                -50,
                -50
              ],
              [
                50,
                -50
              ],
              [
                50,
                50
              ]
            ]
          ]
        },
        {
          "name": "cube3",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -50,
                50
              ],
              [
                -50,
                -50
              ],
              [
                50,
                -50
              ],
              [
                50,
                50
              ]
            ]
          ]
        },
        {
          "name": "mainRampa",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                1285.9,
                164.95
              ],
              [
                1287.9,
                174.45
              ],
              [
                1276.4,
                177.95
              ],
              [
                1282.9,
                153.95
              ]
            ],
            [
              [
                1287.9,
                174.45
              ],
              [
                1290.9,
                182.45
              ],
              [
                1276.4,
                177.95
              ]
            ],
            [
              [
                1290.9,
                182.45
              ],
              [
                1294.9,
                189.45
              ],
              [
                1276.4,
                177.95
              ]
            ],
            [
              [
                1294.9,
                189.45
              ],
              [
                1298.4,
                193.45
              ],
              [
                1271.4,
                188.95
              ],
              [
                1276.4,
                177.95
              ]
            ],
            [
              [
                1298.4,
                193.45
              ],
              [
                1303.4,
                196.45
              ],
              [
                1265.9,
                194.95
              ],
              [
                1271.4,
                188.95
              ]
            ],
            [
              [
                1265.9,
                194.95
              ],
              [
                1303.4,
                196.45
              ],
              [
                1257.9,
                198.95
              ]
            ],
            [
              [
                1257.9,
                198.95
              ],
              [
                1303.4,
                196.45
              ],
              [
                1309.65,
                199.2
              ],
              [
                1243.95,
                200.95
              ]
            ],
            [
              [
                434.45,
                165.5
              ],
              [
                436.45,
                175
              ],
              [
                424.95,
                178.5
              ],
              [
                431.45,
                154.5
              ]
            ],
            [
              [
                436.45,
                175
              ],
              [
                439.45,
                183
              ],
              [
                424.95,
                178.5
              ]
            ],
            [
              [
                439.45,
                183
              ],
              [
                443.45,
                190
              ],
              [
                424.95,
                178.5
              ]
            ],
            [
              [
                443.45,
                190
              ],
              [
                446.95,
                194
              ],
              [
                419.95,
                189.5
              ],
              [
                424.95,
                178.5
              ]
            ],
            [
              [
                446.95,
                194
              ],
              [
                451.95,
                197
              ],
              [
                419.95,
                189.5
              ]
            ],
            [
              [
                451.95,
                197
              ],
              [
                458.2,
                199.75
              ],
              [
                414.45,
                195.5
              ],
              [
                419.95,
                189.5
              ]
            ],
            [
              [
                414.45,
                195.5
              ],
              [
                458.2,
                199.75
              ],
              [
                406.45,
                199.5
              ]
            ],
            [
              [
                458.2,
                199.75
              ],
              [
                476.2,
                200.95
              ],
              [
                392.5,
                201.5
              ],
              [
                406.45,
                199.5
              ]
            ],
            [
              [
                476.2,
                200.95
              ],
              [
                1243.95,
                200.95
              ],
              [
                1388.9,
                223
              ],
              [
                0,
                223
              ],
              [
                392.5,
                201.5
              ]
            ],
            [
              [
                161.5,
                109.5
              ],
              [
                183,
                148.5
              ],
              [
                103.95,
                39
              ],
              [
                140.95,
                78.95
              ],
              [
                150.5,
                91.5
              ]
            ],
            [
              [
                183,
                148.5
              ],
              [
                192,
                163
              ],
              [
                58,
                4
              ],
              [
                76,
                14
              ],
              [
                103.95,
                39
              ]
            ],
            [
              [
                192,
                163
              ],
              [
                202,
                175
              ],
              [
                0,
                223
              ],
              [
                0,
                0
              ],
              [
                42,
                0
              ],
              [
                58,
                4
              ]
            ],
            [
              [
                202,
                175
              ],
              [
                215.5,
                186.5
              ],
              [
                0,
                223
              ]
            ],
            [
              [
                215.5,
                186.5
              ],
              [
                236,
                196.5
              ],
              [
                0,
                223
              ]
            ],
            [
              [
                236,
                196.5
              ],
              [
                256,
                201.5
              ],
              [
                0,
                223
              ]
            ],
            [
              [
                256,
                201.5
              ],
              [
                392.5,
                201.5
              ],
              [
                0,
                223
              ]
            ],
            [
              [
                1388.9,
                223
              ],
              [
                1243.95,
                200.95
              ],
              [
                1327.4,
                200.4
              ],
              [
                1388.9,
                200.4
              ]
            ],
            [
              [
                1327.4,
                200.4
              ],
              [
                1243.95,
                200.95
              ],
              [
                1309.65,
                199.2
              ]
            ]
          ]
        },
        {
          "name": "goBall",
          "shape": "Circle",
          "density": 0.5,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            80
          ]
        },
        {
          "name": "roundBlock",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                127.3,
                26.5
              ],
              [
                122,
                33.3
              ],
              [
                107,
                20.8
              ],
              [
                109.7,
                12.85
              ]
            ],
            [
              [
                84.2,
                2.4
              ],
              [
                109.7,
                12.85
              ],
              [
                82,
                10.3
              ],
              [
                54,
                0
              ]
            ],
            [
              [
                24.95,
                6.5
              ],
              [
                54,
                0
              ],
              [
                27.5,
                13.8
              ],
              [
                0,
                21.7
              ]
            ],
            [
              [
                3.75,
                28.05
              ],
              [
                0,
                21.7
              ],
              [
                27.5,
                13.8
              ]
            ],
            [
              [
                27.5,
                13.8
              ],
              [
                54,
                0
              ],
              [
                54.5,
                8.3
              ]
            ],
            [
              [
                54.5,
                8.3
              ],
              [
                54,
                0
              ],
              [
                82,
                10.3
              ]
            ],
            [
              [
                82,
                10.3
              ],
              [
                109.7,
                12.85
              ],
              [
                107,
                20.8
              ]
            ]
          ]
        }
      ]
    },
    {
      "id": 11,
      "className": "Levels.Level_11",
      "symbolId": 87,
      "svgPath": "port/generated/levels/level_11/1.svg",
      "imagePath": "port/generated/levels_png/level_11/1.png",
      "foregroundSvgPath": null,
      "layout": {
        "imageWidth": 5564.9,
        "imageHeight": 2186.2,
        "imageOffsetX": -3408.75,
        "imageOffsetY": -1674.75,
        "namedChildren": {
          "backGroundMC": {
            "x": -1600.25,
            "y": -1058.1,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "vagon11": {
            "x": -2787.75,
            "y": -166.8,
            "width": 74.55,
            "height": 27.1,
            "rotation": 0.17419600012960887
          },
          "koleso_11_2": {
            "x": -2852.95,
            "y": -158.7,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "koleso_11_1": {
            "x": -2806.4,
            "y": -158.8,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "vagon10": {
            "x": -2710.6,
            "y": -166.65,
            "width": 74.55,
            "height": 27.1,
            "rotation": 0.17419600012960887
          },
          "koleso_10_2": {
            "x": -2775.8,
            "y": -158.55,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "koleso_10_1": {
            "x": -2729.25,
            "y": -158.55,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "vagon9": {
            "x": -2632.65,
            "y": -166.4,
            "width": 74.55,
            "height": 27.1,
            "rotation": 0.17419600012960887
          },
          "koleso_9_2": {
            "x": -2697.9,
            "y": -158.3,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "koleso_9_1": {
            "x": -2651.35,
            "y": -158.3,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "vagon8": {
            "x": -2555.25,
            "y": -166.15,
            "width": 74.55,
            "height": 27.1,
            "rotation": 0.17419600012960887
          },
          "koleso_8_2": {
            "x": -2620.45,
            "y": -158.05,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "koleso_8_1": {
            "x": -2573.9,
            "y": -158.1,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "vagon7": {
            "x": -2478.1,
            "y": -165.85,
            "width": 74.55,
            "height": 27.1,
            "rotation": 0.17419600012960887
          },
          "koleso_7_2": {
            "x": -2543.3,
            "y": -157.8,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "koleso_7_1": {
            "x": -2496.75,
            "y": -157.9,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "vagon6": {
            "x": -2400.75,
            "y": -165.6,
            "width": 74.55,
            "height": 27.1,
            "rotation": 0.17419600012960887
          },
          "koleso_6_2": {
            "x": -2465.95,
            "y": -157.55,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "koleso_6_1": {
            "x": -2419.35,
            "y": -157.6,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "vagon5": {
            "x": -2323.5,
            "y": -165.4,
            "width": 74.55,
            "height": 27.1,
            "rotation": 0.17419600012960887
          },
          "koleso_5_2": {
            "x": -2388.8,
            "y": -157.35,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "koleso_5_1": {
            "x": -2342.2,
            "y": -157.45,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "vagon4": {
            "x": -2246.1,
            "y": -165.25,
            "width": 74.55,
            "height": 27.1,
            "rotation": 0.17419600012960887
          },
          "koleso_4_2": {
            "x": -2311.35,
            "y": -157.15,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "koleso_4_1": {
            "x": -2264.85,
            "y": -157.25,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "vagon3": {
            "x": -2169.05,
            "y": -164.95,
            "width": 74.55,
            "height": 27.1,
            "rotation": 0.17419600012960887
          },
          "koleso_3_2": {
            "x": -2234.2,
            "y": -156.9,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "koleso_3_1": {
            "x": -2187.65,
            "y": -156.9,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "vagon2": {
            "x": -2091.8,
            "y": -164.8,
            "width": 74.55,
            "height": 27.1,
            "rotation": 0.17419600012960887
          },
          "koleso_2_2": {
            "x": -2157.0,
            "y": -156.7,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "koleso_2_1": {
            "x": -2110.5,
            "y": -156.75,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "vagon1": {
            "x": -2014.7,
            "y": -164.55,
            "width": 74.55,
            "height": 27.1,
            "rotation": 0.17419600012960887
          },
          "koleso_1_2": {
            "x": -2079.85,
            "y": -156.45,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "koleso_1_1": {
            "x": -2033.35,
            "y": -156.55,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "kolesoTrain2": {
            "x": -2003.45,
            "y": -156.45,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "kolesoTrain1": {
            "x": -1966.7,
            "y": -156.3,
            "width": 8.95,
            "height": 9.0,
            "rotation": 0.17419600012960887
          },
          "train": {
            "x": -2013.0,
            "y": -164.6,
            "width": 62.3,
            "height": 28.4,
            "rotation": 0.17419600012960887
          },
          "platform": {
            "x": -2870.0,
            "y": -146.95,
            "width": 4175.0,
            "height": 300.5,
            "rotation": 0.0
          },
          "ceil1": {
            "x": -2870.0,
            "y": -226.0,
            "width": 690.0,
            "height": 301.0,
            "rotation": 0.0
          },
          "killCeil1": {
            "x": -1938.4,
            "y": -231.0,
            "width": 251.0,
            "height": 36.4,
            "rotation": 0.0
          },
          "ceil2_1": {
            "x": -1612.0,
            "y": -210.05,
            "width": 235.85,
            "height": 146.4,
            "rotation": 0.0
          },
          "ceil2_2": {
            "x": -1394.0,
            "y": -210.05,
            "width": 235.85,
            "height": 146.4,
            "rotation": 0.0
          },
          "killRotate": {
            "x": -1450.95,
            "y": -240.0,
            "width": 11.0,
            "height": 81.0,
            "rotation": 0.0
          },
          "killStar1": {
            "x": -1059.5,
            "y": -230.0,
            "width": 41.0,
            "height": 41.0,
            "rotation": 0.0
          },
          "killStar2": {
            "x": -1011.5,
            "y": -230.0,
            "width": 41.0,
            "height": 41.0,
            "rotation": 0.0
          },
          "killStar0": {
            "x": -1107.5,
            "y": -230.0,
            "width": 41.0,
            "height": 41.0,
            "rotation": 0.0
          },
          "levelAim": {
            "x": -2056.05,
            "y": -194.9,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "killBrevno0": {
            "x": -2541.85,
            "y": -169.75,
            "width": 53.75,
            "height": 4.0,
            "rotation": 0.0
          },
          "killBrevno1": {
            "x": -2540.6,
            "y": -173.75,
            "width": 53.75,
            "height": 4.0,
            "rotation": 0.0
          },
          "killBrevno2": {
            "x": -2543.1,
            "y": -177.75,
            "width": 53.75,
            "height": 4.0,
            "rotation": 0.0
          },
          "killBrevno3": {
            "x": -2541.35,
            "y": -181.5,
            "width": 53.75,
            "height": 4.0,
            "rotation": 0.0
          },
          "triangle": {
            "x": -742.7,
            "y": -239.1,
            "width": 585.75,
            "height": 511.7,
            "rotation": 0.751207790305389
          },
          "upCeil": {
            "x": -397.95,
            "y": -254.95,
            "width": 845.55,
            "height": 300.5,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": -2831.9,
            "y": -185.65,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5595,
        "sourceHeight": 2217,
        "cropX": 8,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2201
      },
      "symbols": {},
      "bodies": [
        {
          "name": "levelAim",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                7.9,
                12.9
              ],
              [
                15.65,
                30.15
              ],
              [
                -9.6,
                30.15
              ],
              [
                -0.35,
                12.9
              ]
            ]
          ]
        },
        {
          "name": "train",
          "shape": "Polygon",
          "density": 5.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                23.75,
                -21.05
              ],
              [
                23.75,
                -9.3
              ],
              [
                3.35,
                -1.2
              ],
              [
                3.35,
                -21.05
              ]
            ],
            [
              [
                0.45,
                -2.6
              ],
              [
                3.35,
                -1.2
              ],
              [
                3.35,
                1.3
              ],
              [
                0.45,
                2.9
              ]
            ],
            [
              [
                3.35,
                -1.2
              ],
              [
                23.75,
                -9.3
              ],
              [
                3.35,
                1.3
              ]
            ],
            [
              [
                3.35,
                1.3
              ],
              [
                23.75,
                -9.3
              ],
              [
                41.75,
                -9.3
              ],
              [
                46.15,
                -9.2
              ],
              [
                58,
                2.35
              ],
              [
                61.75,
                6.35
              ],
              [
                3.35,
                6.35
              ]
            ],
            [
              [
                58,
                -9.2
              ],
              [
                58,
                2.35
              ],
              [
                46.15,
                -9.2
              ]
            ],
            [
              [
                47.25,
                -15.9
              ],
              [
                46.15,
                -9.2
              ],
              [
                41.75,
                -9.3
              ],
              [
                40,
                -15.9
              ]
            ]
          ]
        },
        {
          "name": "kolesoTrain1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "kolesoTrain2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "platform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                2658.9,
                -33.95
              ],
              [
                2857.8,
                -33.95
              ],
              [
                3289.85,
                0
              ],
              [
                2100.95,
                0
              ]
            ],
            [
              [
                0,
                0
              ],
              [
                2100.95,
                0
              ],
              [
                3718.9,
                7.95
              ],
              [
                3650,
                20
              ],
              [
                0,
                20
              ]
            ],
            [
              [
                3793,
                80.7
              ],
              [
                3777.9,
                60.65
              ],
              [
                3808.7,
                69.5
              ]
            ],
            [
              [
                3777.9,
                60.65
              ],
              [
                3755.7,
                40.8
              ],
              [
                3791.3,
                45.7
              ],
              [
                3808.7,
                69.5
              ]
            ],
            [
              [
                3755.7,
                40.8
              ],
              [
                3714.1,
                28.3
              ],
              [
                3762.1,
                21.5
              ],
              [
                3791.3,
                45.7
              ]
            ],
            [
              [
                3714.1,
                28.3
              ],
              [
                3650,
                20
              ],
              [
                3718.9,
                7.95
              ],
              [
                3762.1,
                21.5
              ]
            ],
            [
              [
                3655.75,
                0
              ],
              [
                3718.9,
                7.95
              ],
              [
                3289.85,
                0
              ]
            ],
            [
              [
                3718.9,
                7.95
              ],
              [
                2100.95,
                0
              ],
              [
                3289.85,
                0
              ]
            ]
          ]
        },
        {
          "name": "ceil1",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                659.95,
                0
              ],
              [
                659.95,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "killCeil1",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                250,
                5
              ],
              [
                250,
                20
              ],
              [
                37,
                14.15
              ],
              [
                16.05,
                12.95
              ],
              [
                0,
                5
              ]
            ],
            [
              [
                0,
                20
              ],
              [
                0,
                5
              ],
              [
                16.05,
                12.95
              ],
              [
                9.1,
                27.5
              ]
            ],
            [
              [
                22.4,
                20
              ],
              [
                16.05,
                12.95
              ],
              [
                22.4,
                17
              ]
            ],
            [
              [
                29.35,
                32.6
              ],
              [
                22.4,
                17
              ],
              [
                37,
                14.15
              ]
            ],
            [
              [
                22.4,
                17
              ],
              [
                16.05,
                12.95
              ],
              [
                37,
                14.15
              ]
            ],
            [
              [
                48.9,
                35.5
              ],
              [
                37,
                14.15
              ],
              [
                53.15,
                26.1
              ]
            ],
            [
              [
                57.25,
                29.5
              ],
              [
                53.15,
                26.1
              ],
              [
                62.15,
                15.75
              ]
            ],
            [
              [
                53.15,
                26.1
              ],
              [
                37,
                14.15
              ],
              [
                62.15,
                15.75
              ]
            ],
            [
              [
                37,
                14.15
              ],
              [
                250,
                20
              ],
              [
                111.05,
                16.95
              ],
              [
                62.15,
                15.75
              ]
            ],
            [
              [
                71.25,
                26.5
              ],
              [
                62.15,
                15.75
              ],
              [
                84.5,
                17.3
              ]
            ],
            [
              [
                91.5,
                34.55
              ],
              [
                84.5,
                17.3
              ],
              [
                95.75,
                23.8
              ]
            ],
            [
              [
                102.65,
                32.65
              ],
              [
                95.75,
                23.8
              ],
              [
                111.05,
                16.95
              ]
            ],
            [
              [
                95.75,
                23.8
              ],
              [
                84.5,
                17.3
              ],
              [
                111.05,
                16.95
              ]
            ],
            [
              [
                84.5,
                17.3
              ],
              [
                62.15,
                15.75
              ],
              [
                111.05,
                16.95
              ]
            ],
            [
              [
                118,
                28.2
              ],
              [
                111.05,
                16.95
              ],
              [
                121.5,
                23.8
              ]
            ],
            [
              [
                125.75,
                37.1
              ],
              [
                121.5,
                23.8
              ],
              [
                137,
                20
              ]
            ],
            [
              [
                121.5,
                23.8
              ],
              [
                111.05,
                16.95
              ],
              [
                137,
                20
              ]
            ],
            [
              [
                142.45,
                29
              ],
              [
                137,
                20
              ],
              [
                148.75,
                20
              ]
            ],
            [
              [
                137,
                20
              ],
              [
                111.05,
                16.95
              ],
              [
                148.75,
                20
              ]
            ],
            [
              [
                153.65,
                34
              ],
              [
                148.75,
                20
              ],
              [
                166.25,
                20
              ],
              [
                161.45,
                40.4
              ]
            ],
            [
              [
                148.75,
                20
              ],
              [
                111.05,
                16.95
              ],
              [
                166.25,
                20
              ]
            ],
            [
              [
                173.2,
                35.5
              ],
              [
                166.25,
                20
              ],
              [
                179.2,
                27.25
              ],
              [
                179.2,
                39.8
              ]
            ],
            [
              [
                184.3,
                33.15
              ],
              [
                179.2,
                27.25
              ],
              [
                189.95,
                23.5
              ]
            ],
            [
              [
                179.2,
                27.25
              ],
              [
                166.25,
                20
              ],
              [
                189.95,
                23.5
              ]
            ],
            [
              [
                199.15,
                39.45
              ],
              [
                189.95,
                23.5
              ],
              [
                209.9,
                20
              ]
            ],
            [
              [
                189.95,
                23.5
              ],
              [
                166.25,
                20
              ],
              [
                209.9,
                20
              ]
            ],
            [
              [
                166.25,
                20
              ],
              [
                111.05,
                16.95
              ],
              [
                209.9,
                20
              ]
            ],
            [
              [
                111.05,
                16.95
              ],
              [
                250,
                20
              ],
              [
                209.9,
                20
              ]
            ],
            [
              [
                209.9,
                20
              ],
              [
                250,
                20
              ],
              [
                232.15,
                31
              ],
              [
                219.3,
                31
              ]
            ],
            [
              [
                242.3,
                39
              ],
              [
                235.55,
                20
              ],
              [
                250,
                20
              ]
            ],
            [
              [
                235.55,
                20
              ],
              [
                250,
                20
              ],
              [
                232.15,
                31
              ]
            ]
          ]
        },
        {
          "name": "ceil2_1",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                10
              ],
              [
                0,
                10
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "ceil2_2",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                10
              ],
              [
                0,
                10
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "killRotate",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                5,
                -40
              ],
              [
                5,
                40
              ],
              [
                -5,
                40
              ],
              [
                -5,
                -40
              ]
            ]
          ]
        },
        {
          "name": "triangle",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                0,
                40
              ],
              [
                185,
                0
              ],
              [
                187,
                27
              ]
            ]
          ]
        },
        {
          "name": "upCeil",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -30.5,
                34.5
              ],
              [
                -13.5,
                13.05
              ],
              [
                0,
                36
              ],
              [
                -30.5,
                38.5
              ]
            ],
            [
              [
                0,
                36
              ],
              [
                -13.5,
                13.05
              ],
              [
                175,
                24
              ]
            ],
            [
              [
                175,
                24
              ],
              [
                -13.5,
                13.05
              ],
              [
                174.95,
                0
              ],
              [
                389,
                0
              ],
              [
                602.45,
                18.6
              ],
              [
                390.95,
                24
              ]
            ],
            [
              [
                621.45,
                41.5
              ],
              [
                390.95,
                24
              ],
              [
                602.45,
                18.6
              ],
              [
                621.45,
                36.65
              ]
            ]
          ]
        },
        {
          "name": "vagon1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -71.35,
                -20.45
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -71.35,
                -1.2
              ]
            ],
            [
              [
                -74.15,
                -2.8
              ],
              [
                -71.35,
                -1.2
              ],
              [
                -71.35,
                1.05
              ],
              [
                -74.15,
                2.7
              ]
            ],
            [
              [
                -71.35,
                -1.2
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -71.35,
                1.05
              ]
            ],
            [
              [
                -71.35,
                1.05
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -66.4,
                1
              ],
              [
                -71.35,
                5.6
              ]
            ],
            [
              [
                -3.4,
                5.6
              ],
              [
                -71.35,
                5.6
              ],
              [
                -66.4,
                1
              ],
              [
                -8.15,
                1
              ],
              [
                -3.4,
                1.05
              ]
            ],
            [
              [
                -0.6,
                2.7
              ],
              [
                -3.4,
                1.05
              ],
              [
                -3.4,
                -1.2
              ],
              [
                -0.6,
                -2.8
              ]
            ],
            [
              [
                -3.4,
                -1.2
              ],
              [
                -3.4,
                1.05
              ],
              [
                -3.4,
                -20.5
              ]
            ],
            [
              [
                -3.4,
                -20.5
              ],
              [
                -3.4,
                1.05
              ],
              [
                -8.15,
                1
              ],
              [
                -8.15,
                -20.5
              ]
            ]
          ]
        },
        {
          "name": "koleso_1_1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "koleso_1_2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "vagon2",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -71.35,
                -20.45
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -71.35,
                -1.2
              ]
            ],
            [
              [
                -74.15,
                -2.8
              ],
              [
                -71.35,
                -1.2
              ],
              [
                -71.35,
                1.05
              ],
              [
                -74.15,
                2.7
              ]
            ],
            [
              [
                -71.35,
                -1.2
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -71.35,
                1.05
              ]
            ],
            [
              [
                -71.35,
                1.05
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -66.4,
                1
              ],
              [
                -71.35,
                5.6
              ]
            ],
            [
              [
                -3.4,
                5.6
              ],
              [
                -71.35,
                5.6
              ],
              [
                -66.4,
                1
              ],
              [
                -8.15,
                1
              ],
              [
                -3.4,
                1.05
              ]
            ],
            [
              [
                -0.6,
                2.7
              ],
              [
                -3.4,
                1.05
              ],
              [
                -3.4,
                -1.2
              ],
              [
                -0.6,
                -2.8
              ]
            ],
            [
              [
                -3.4,
                -1.2
              ],
              [
                -3.4,
                1.05
              ],
              [
                -3.4,
                -20.5
              ]
            ],
            [
              [
                -3.4,
                -20.5
              ],
              [
                -3.4,
                1.05
              ],
              [
                -8.15,
                1
              ],
              [
                -8.15,
                -20.5
              ]
            ]
          ]
        },
        {
          "name": "koleso_2_1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "koleso_2_2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "vagon3",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -71.35,
                -20.45
              ],
              [
                -3.4,
                -20.5
              ],
              [
                -3.4,
                5.6
              ],
              [
                -71.35,
                5.6
              ]
            ]
          ]
        },
        {
          "name": "koleso_3_1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "koleso_3_2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "vagon4",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -71.35,
                -20.45
              ],
              [
                -3.4,
                -20.5
              ],
              [
                -3.4,
                5.6
              ],
              [
                -71.35,
                5.6
              ]
            ]
          ]
        },
        {
          "name": "koleso_4_1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "koleso_4_2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "vagon5",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -71.35,
                -20.45
              ],
              [
                -3.4,
                -20.5
              ],
              [
                -3.4,
                5.6
              ],
              [
                -71.35,
                5.6
              ]
            ]
          ]
        },
        {
          "name": "koleso_5_1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "koleso_5_2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "vagon6",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -71.35,
                -20.45
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -71.35,
                -1.2
              ]
            ],
            [
              [
                -74.15,
                -2.8
              ],
              [
                -71.35,
                -1.2
              ],
              [
                -71.35,
                1.05
              ],
              [
                -74.15,
                2.7
              ]
            ],
            [
              [
                -71.35,
                -1.2
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -71.35,
                1.05
              ]
            ],
            [
              [
                -71.35,
                1.05
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -66.4,
                1
              ],
              [
                -71.35,
                5.6
              ]
            ],
            [
              [
                -3.4,
                5.6
              ],
              [
                -71.35,
                5.6
              ],
              [
                -66.4,
                1
              ],
              [
                -8.15,
                1
              ],
              [
                -3.4,
                1.05
              ]
            ],
            [
              [
                -0.6,
                2.7
              ],
              [
                -3.4,
                1.05
              ],
              [
                -3.4,
                -1.2
              ],
              [
                -0.6,
                -2.8
              ]
            ],
            [
              [
                -3.4,
                -1.2
              ],
              [
                -3.4,
                1.05
              ],
              [
                -3.4,
                -20.5
              ]
            ],
            [
              [
                -3.4,
                -20.5
              ],
              [
                -3.4,
                1.05
              ],
              [
                -8.15,
                1
              ],
              [
                -8.15,
                -20.5
              ]
            ]
          ]
        },
        {
          "name": "koleso_6_1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "koleso_6_2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "vagon7",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -71.35,
                -20.45
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -71.35,
                -1.2
              ]
            ],
            [
              [
                -74.15,
                -2.8
              ],
              [
                -71.35,
                -1.2
              ],
              [
                -71.35,
                1.05
              ],
              [
                -74.15,
                2.7
              ]
            ],
            [
              [
                -71.35,
                -1.2
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -71.35,
                1.05
              ]
            ],
            [
              [
                -71.35,
                1.05
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -66.4,
                1
              ],
              [
                -71.35,
                5.6
              ]
            ],
            [
              [
                -3.4,
                5.6
              ],
              [
                -71.35,
                5.6
              ],
              [
                -66.4,
                1
              ],
              [
                -8.15,
                1
              ],
              [
                -3.4,
                1.05
              ]
            ],
            [
              [
                -0.6,
                2.7
              ],
              [
                -3.4,
                1.05
              ],
              [
                -3.4,
                -1.2
              ],
              [
                -0.6,
                -2.8
              ]
            ],
            [
              [
                -3.4,
                -1.2
              ],
              [
                -3.4,
                1.05
              ],
              [
                -3.4,
                -20.5
              ]
            ],
            [
              [
                -3.4,
                -20.5
              ],
              [
                -3.4,
                1.05
              ],
              [
                -8.15,
                1
              ],
              [
                -8.15,
                -20.5
              ]
            ]
          ]
        },
        {
          "name": "koleso_7_1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "koleso_7_2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "vagon8",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -71.35,
                -20.45
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -71.35,
                -1.2
              ]
            ],
            [
              [
                -74.15,
                -2.8
              ],
              [
                -71.35,
                -1.2
              ],
              [
                -71.35,
                1.05
              ],
              [
                -74.15,
                2.7
              ]
            ],
            [
              [
                -71.35,
                -1.2
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -71.35,
                1.05
              ]
            ],
            [
              [
                -71.35,
                1.05
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -66.4,
                1
              ],
              [
                -71.35,
                5.6
              ]
            ],
            [
              [
                -3.4,
                5.6
              ],
              [
                -71.35,
                5.6
              ],
              [
                -66.4,
                1
              ],
              [
                -8.15,
                1
              ],
              [
                -3.4,
                1.05
              ]
            ],
            [
              [
                -0.6,
                2.7
              ],
              [
                -3.4,
                1.05
              ],
              [
                -3.4,
                -1.2
              ],
              [
                -0.6,
                -2.8
              ]
            ],
            [
              [
                -3.4,
                -1.2
              ],
              [
                -3.4,
                1.05
              ],
              [
                -3.4,
                -20.5
              ]
            ],
            [
              [
                -3.4,
                -20.5
              ],
              [
                -3.4,
                1.05
              ],
              [
                -8.15,
                1
              ],
              [
                -8.15,
                -20.5
              ]
            ]
          ]
        },
        {
          "name": "koleso_8_1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "koleso_8_2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "vagon9",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -71.35,
                -20.45
              ],
              [
                -3.4,
                -20.5
              ],
              [
                -3.4,
                5.6
              ],
              [
                -71.35,
                5.6
              ]
            ]
          ]
        },
        {
          "name": "koleso_9_1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "koleso_9_2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "vagon10",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -71.35,
                -20.45
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -71.35,
                -1.2
              ]
            ],
            [
              [
                -74.15,
                -2.8
              ],
              [
                -71.35,
                -1.2
              ],
              [
                -71.35,
                1.05
              ],
              [
                -74.15,
                2.7
              ]
            ],
            [
              [
                -71.35,
                -1.2
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -71.35,
                1.05
              ]
            ],
            [
              [
                -71.35,
                1.05
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -66.4,
                1
              ],
              [
                -71.35,
                5.6
              ]
            ],
            [
              [
                -3.4,
                5.6
              ],
              [
                -71.35,
                5.6
              ],
              [
                -66.4,
                1
              ],
              [
                -8.15,
                1
              ],
              [
                -3.4,
                1.05
              ]
            ],
            [
              [
                -0.6,
                2.7
              ],
              [
                -3.4,
                1.05
              ],
              [
                -3.4,
                -1.2
              ],
              [
                -0.6,
                -2.8
              ]
            ],
            [
              [
                -3.4,
                -1.2
              ],
              [
                -3.4,
                1.05
              ],
              [
                -3.4,
                -20.5
              ]
            ],
            [
              [
                -3.4,
                -20.5
              ],
              [
                -3.4,
                1.05
              ],
              [
                -8.15,
                1
              ],
              [
                -8.15,
                -20.5
              ]
            ]
          ]
        },
        {
          "name": "koleso_10_1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "koleso_10_2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "vagon11",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -71.35,
                -20.45
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -71.35,
                -1.2
              ]
            ],
            [
              [
                -74.15,
                -2.8
              ],
              [
                -71.35,
                -1.2
              ],
              [
                -71.35,
                1.05
              ],
              [
                -74.15,
                2.7
              ]
            ],
            [
              [
                -71.35,
                -1.2
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -71.35,
                1.05
              ]
            ],
            [
              [
                -71.35,
                1.05
              ],
              [
                -66.4,
                -20.45
              ],
              [
                -66.4,
                1
              ],
              [
                -71.35,
                5.6
              ]
            ],
            [
              [
                -3.4,
                5.6
              ],
              [
                -71.35,
                5.6
              ],
              [
                -66.4,
                1
              ],
              [
                -8.15,
                1
              ],
              [
                -3.4,
                1.05
              ]
            ],
            [
              [
                -0.6,
                2.7
              ],
              [
                -3.4,
                1.05
              ],
              [
                -3.4,
                -1.2
              ],
              [
                -0.6,
                -2.8
              ]
            ],
            [
              [
                -3.4,
                -1.2
              ],
              [
                -3.4,
                1.05
              ],
              [
                -3.4,
                -20.5
              ]
            ],
            [
              [
                -3.4,
                -20.5
              ],
              [
                -3.4,
                1.05
              ],
              [
                -8.15,
                1
              ],
              [
                -8.15,
                -20.5
              ]
            ]
          ]
        },
        {
          "name": "koleso_11_1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "koleso_11_2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "killStar0",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            40
          ]
        },
        {
          "name": "killStar1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            40
          ]
        },
        {
          "name": "killStar2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            40
          ]
        },
        {
          "name": "killBrevno0",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                52.75,
                0
              ],
              [
                52.75,
                3
              ],
              [
                0,
                3
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "killBrevno1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                52.75,
                0
              ],
              [
                52.75,
                3
              ],
              [
                0,
                3
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "killBrevno2",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                52.75,
                0
              ],
              [
                52.75,
                3
              ],
              [
                0,
                3
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "killBrevno3",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                52.75,
                0
              ],
              [
                52.75,
                3
              ],
              [
                0,
                3
              ],
              [
                0,
                0
              ]
            ]
          ]
        }
      ]
    },
    {
      "id": 12,
      "className": "Levels.Level_12",
      "symbolId": 164,
      "svgPath": "port/generated/levels/level_12/1.svg",
      "imagePath": "port/generated/levels_png/level_12/1.png",
      "foregroundSvgPath": null,
      "layout": {
        "imageWidth": 5564.9,
        "imageHeight": 2186.2,
        "imageOffsetX": -2600.55,
        "imageOffsetY": -1486.7,
        "namedChildren": {
          "killStar": {
            "x": -1058.4,
            "y": -66.8,
            "width": 41.0,
            "height": 41.0,
            "rotation": 0.0
          },
          "backGroundMC": {
            "x": -792.05,
            "y": -870.05,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "levelAim": {
            "x": 368.0,
            "y": -128.05,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "box0": {
            "x": -1994.35,
            "y": -111.5,
            "width": 174.0,
            "height": 97.0,
            "rotation": 0.0
          },
          "box1": {
            "x": -1994.35,
            "y": -132.75,
            "width": 174.0,
            "height": 97.0,
            "rotation": 0.0
          },
          "box2": {
            "x": -1994.35,
            "y": -154.0,
            "width": 174.0,
            "height": 97.0,
            "rotation": 0.0
          },
          "steps": {
            "x": -2407.0,
            "y": -52.0,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "boxPlatform": {
            "x": -2074.0,
            "y": -90.0,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "mainPlatform": {
            "x": -2506.9,
            "y": -87.25,
            "width": 2082.55,
            "height": 1055.2,
            "rotation": 0.0
          },
          "ceil": {
            "x": -1622.65,
            "y": -136.75,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "bigBox": {
            "x": -1340.95,
            "y": -0.5,
            "width": 193.15,
            "height": 138.75,
            "rotation": 0.0
          },
          "rampa": {
            "x": -632.95,
            "y": -167.0,
            "width": 1084.35,
            "height": 488.9,
            "rotation": 0.0
          },
          "roll1": {
            "x": -606.1,
            "y": -176.55,
            "width": 379.5,
            "height": 348.9,
            "rotation": 0.0
          },
          "roll2": {
            "x": -595.95,
            "y": -176.8,
            "width": 379.5,
            "height": 348.9,
            "rotation": 0.0
          },
          "goPlat": {
            "x": -627.2,
            "y": -125.25,
            "width": 60.75,
            "height": 16.75,
            "rotation": 0.0
          },
          "fiveMoreLevelsText": {
            "x": 193.7,
            "y": -198.5,
            "width": 365.25,
            "height": 50.55,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": -2035.0,
            "y": 61.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint1": {
            "x": -2235.95,
            "y": -72.15,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint2": {
            "x": -1528.0,
            "y": 20.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint3": {
            "x": -678.05,
            "y": -105.65,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "kingLogo": {
            "x": 373.3,
            "y": -238.95,
            "width": 0.0,
            "height": 0.0,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5595,
        "sourceHeight": 2217,
        "cropX": 8,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2201
      },
      "symbols": {},
      "bodies": [
        {
          "name": "steps",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                256,
                0
              ],
              [
                256,
                18
              ],
              [
                164,
                18
              ],
              [
                138,
                0
              ]
            ],
            [
              [
                112,
                18
              ],
              [
                138,
                18
              ],
              [
                164,
                106
              ],
              [
                112,
                37
              ]
            ],
            [
              [
                87,
                37
              ],
              [
                112,
                37
              ],
              [
                164,
                106
              ],
              [
                87,
                55
              ]
            ],
            [
              [
                62,
                55
              ],
              [
                87,
                55
              ],
              [
                62,
                72
              ]
            ],
            [
              [
                38.5,
                72
              ],
              [
                62,
                72
              ],
              [
                38.5,
                88.5
              ]
            ],
            [
              [
                62,
                72
              ],
              [
                87,
                55
              ],
              [
                164,
                106
              ],
              [
                38.5,
                88.5
              ]
            ],
            [
              [
                0,
                88.5
              ],
              [
                38.5,
                88.5
              ],
              [
                164,
                106
              ],
              [
                0,
                106
              ]
            ],
            [
              [
                138,
                18
              ],
              [
                138,
                0
              ],
              [
                164,
                18
              ],
              [
                164,
                106
              ]
            ]
          ]
        },
        {
          "name": "mainPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                1962.2,
                0
              ],
              [
                1962.2,
                18.05
              ],
              [
                1817.45,
                7.75
              ],
              [
                1817.45,
                0
              ]
            ],
            [
              [
                1817.45,
                7.75
              ],
              [
                1962.2,
                18.05
              ],
              [
                1799.45,
                15.75
              ],
              [
                1799.45,
                7.75
              ]
            ],
            [
              [
                1799.45,
                15.75
              ],
              [
                1962.2,
                18.05
              ],
              [
                1883.2,
                18.05
              ],
              [
                1779.95,
                15.75
              ]
            ],
            [
              [
                1761.2,
                24
              ],
              [
                1779.95,
                24
              ],
              [
                1761.2,
                31.5
              ]
            ],
            [
              [
                1741.95,
                31.5
              ],
              [
                1761.2,
                31.5
              ],
              [
                1741.95,
                39.25
              ]
            ],
            [
              [
                1761.2,
                31.5
              ],
              [
                1779.95,
                24
              ],
              [
                1883.2,
                193.25
              ],
              [
                1741.95,
                39.25
              ]
            ],
            [
              [
                1431.65,
                39.25
              ],
              [
                1741.95,
                39.25
              ],
              [
                1883.2,
                193.25
              ],
              [
                1431.65,
                127.4
              ]
            ],
            [
              [
                884.25,
                127.4
              ],
              [
                1431.65,
                127.4
              ],
              [
                1883.2,
                193.25
              ],
              [
                884.25,
                168.2
              ]
            ],
            [
              [
                533,
                127.2
              ],
              [
                533,
                168.2
              ],
              [
                511.5,
                168.25
              ],
              [
                511.5,
                127.2
              ]
            ],
            [
              [
                533,
                168.2
              ],
              [
                884.25,
                168.2
              ],
              [
                1883.2,
                193.25
              ],
              [
                0,
                193.25
              ],
              [
                511.5,
                168.25
              ]
            ],
            [
              [
                0,
                168.25
              ],
              [
                511.5,
                168.25
              ],
              [
                0,
                193.25
              ]
            ],
            [
              [
                1779.95,
                24
              ],
              [
                1779.95,
                15.75
              ],
              [
                1883.2,
                18.05
              ],
              [
                1883.2,
                193.25
              ]
            ]
          ]
        },
        {
          "name": "boxPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                18
              ],
              [
                0,
                18
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "ceil",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                184,
                0
              ],
              [
                184,
                140.25
              ],
              [
                0,
                140.25
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "bigBox",
          "shape": "Polygon",
          "density": 0.125,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                0,
                0
              ],
              [
                40,
                0
              ],
              [
                40,
                40
              ],
              [
                0,
                40
              ]
            ]
          ]
        },
        {
          "name": "killStar",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            40
          ]
        },
        {
          "name": "rampa",
          "shape": "Polygon",
          "density": 0,
          "friction": 0.1,
          "restitution": 0.2,
          "data": [
            [
              [
                11.6,
                -14.25
              ],
              [
                11.6,
                -8.2
              ],
              [
                5.6,
                -8.2
              ],
              [
                0,
                -14.25
              ]
            ],
            [
              [
                435.5,
                84.5
              ],
              [
                354.5,
                64.5
              ],
              [
                451,
                87.5
              ]
            ],
            [
              [
                354.5,
                64.5
              ],
              [
                210.95,
                30
              ],
              [
                505.5,
                94
              ],
              [
                483.5,
                92.5
              ],
              [
                451,
                87.5
              ]
            ],
            [
              [
                210.95,
                30
              ],
              [
                157.95,
                18
              ],
              [
                450,
                81.5
              ],
              [
                505.5,
                94
              ]
            ],
            [
              [
                996,
                70.6
              ],
              [
                1015,
                70.6
              ],
              [
                1009,
                76.6
              ],
              [
                996,
                76.6
              ]
            ],
            [
              [
                1015,
                70.6
              ],
              [
                1015,
                94
              ],
              [
                1009,
                88.5
              ],
              [
                1009,
                76.6
              ]
            ],
            [
              [
                1015,
                94
              ],
              [
                505.5,
                94
              ],
              [
                507.5,
                88.5
              ],
              [
                1009,
                88.5
              ]
            ],
            [
              [
                507.5,
                88.5
              ],
              [
                505.5,
                94
              ],
              [
                483,
                86.5
              ]
            ],
            [
              [
                483,
                86.5
              ],
              [
                505.5,
                94
              ],
              [
                450,
                81.5
              ]
            ],
            [
              [
                450,
                81.5
              ],
              [
                157.95,
                18
              ],
              [
                420,
                74.5
              ]
            ],
            [
              [
                420,
                74.5
              ],
              [
                157.95,
                18
              ],
              [
                211,
                23.5
              ],
              [
                353.5,
                57.5
              ]
            ],
            [
              [
                157.95,
                18
              ],
              [
                110,
                12
              ],
              [
                158,
                11.5
              ],
              [
                211,
                23.5
              ]
            ],
            [
              [
                110,
                12
              ],
              [
                58.75,
                7
              ],
              [
                110,
                5.5
              ],
              [
                158,
                11.5
              ]
            ],
            [
              [
                58.75,
                7
              ],
              [
                0,
                7
              ],
              [
                5.6,
                0
              ],
              [
                58.75,
                0
              ],
              [
                110,
                5.5
              ]
            ],
            [
              [
                0,
                7
              ],
              [
                0,
                -14.25
              ],
              [
                5.6,
                -8.2
              ],
              [
                5.6,
                0
              ]
            ]
          ]
        },
        {
          "name": "roll1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 0.1,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "roll2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 0.1,
          "restitution": 0.2,
          "data": [
            8
          ]
        },
        {
          "name": "goPlat",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                5.45,
                0.75
              ],
              [
                5.45,
                10.1
              ],
              [
                0,
                15.75
              ],
              [
                0,
                0.75
              ]
            ],
            [
              [
                5.45,
                10.1
              ],
              [
                54.05,
                10.1
              ],
              [
                59.75,
                15.75
              ],
              [
                0,
                15.75
              ]
            ],
            [
              [
                54.05,
                10.1
              ],
              [
                54.05,
                0
              ],
              [
                59.75,
                0
              ],
              [
                59.75,
                15.75
              ]
            ]
          ]
        },
        {
          "name": "box0",
          "shape": "Polygon",
          "density": 0.2,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                20,
                0
              ],
              [
                20,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "box1",
          "shape": "Polygon",
          "density": 0.2,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                20,
                0
              ],
              [
                20,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "box2",
          "shape": "Polygon",
          "density": 0.2,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                20,
                0
              ],
              [
                20,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        }
      ]
    },
    {
      "id": 13,
      "className": "Levels.Level_13",
      "symbolId": 601,
      "svgPath": "port/generated/levels/level_13/1.svg",
      "imagePath": "port/generated/levels_png/level_13/1.png",
      "foregroundSvgPath": null,
      "layout": {
        "imageWidth": 5564.9,
        "imageHeight": 2186.2,
        "imageOffsetX": -2125.05,
        "imageOffsetY": -837.2,
        "namedChildren": {
          "backGroundMC": {
            "x": -316.55,
            "y": -220.55,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "levelAim": {
            "x": 71.95,
            "y": 185.65,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": -1770.15,
            "y": 262.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "kingStar1": {
            "x": -1449.95,
            "y": 153.35,
            "width": 151.0,
            "height": 151.0,
            "rotation": -13.132718037677916
          },
          "mainPlat": {
            "x": -1110.45,
            "y": 271.05,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "skyLeft": {
            "x": -1300.45,
            "y": -291.1,
            "width": 298.95,
            "height": 420.8,
            "rotation": 0.0
          },
          "movePlat1": {
            "x": -1058.95,
            "y": 220.95,
            "width": 257.85,
            "height": 142.4,
            "rotation": 0.0
          },
          "checkPoint1": {
            "x": -1351.15,
            "y": 196.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "greenCheck": {
            "x": -1274.05,
            "y": -72.6,
            "width": 11.0,
            "height": 11.0,
            "rotation": 0.0
          },
          "greenBarier": {
            "x": -916.9,
            "y": 140.05,
            "width": 424.25,
            "height": 301.0,
            "rotation": 0.0
          },
          "movePlat2": {
            "x": -338.0,
            "y": 220.95,
            "width": 257.85,
            "height": 142.4,
            "rotation": 0.0
          },
          "checkPoint2": {
            "x": -718.2,
            "y": 196.35,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "pereval": {
            "x": -719.0,
            "y": 225.9,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "pereval2": {
            "x": 77.0,
            "y": 225.9,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "killStar1": {
            "x": -271.0,
            "y": 156.0,
            "width": 31.0,
            "height": 31.0,
            "rotation": 0.0
          },
          "killStar2": {
            "x": -219.0,
            "y": 156.0,
            "width": 31.0,
            "height": 31.0,
            "rotation": 0.0
          },
          "skyRight": {
            "x": -1093.1,
            "y": -289.15,
            "width": 253.5,
            "height": 406.0,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5595,
        "sourceHeight": 2217,
        "cropX": 8,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2201
      },
      "symbols": {},
      "bodies": [
        {
          "name": "mainPlat",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -208.5,
                -55
              ],
              [
                -208.5,
                -34.05
              ],
              [
                -268.45,
                -34.05
              ],
              [
                -268.45,
                -55
              ]
            ],
            [
              [
                -695.55,
                11
              ],
              [
                -624.5,
                11
              ],
              [
                -695.55,
                29
              ]
            ],
            [
              [
                -624.5,
                11
              ],
              [
                -268.45,
                -55
              ],
              [
                -268.45,
                -34.05
              ],
              [
                -622.5,
                29
              ],
              [
                -695.55,
                29
              ]
            ]
          ]
        },
        {
          "name": "kingStar1",
          "shape": "Polygon",
          "density": 2.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                30.65,
                -67.7
              ],
              [
                53,
                -53
              ],
              [
                -18.6,
                -7.65
              ],
              [
                -53.05,
                -53
              ],
              [
                -28.3,
                -69.35
              ],
              [
                -0.05,
                -75
              ]
            ],
            [
              [
                -75.05,
                0
              ],
              [
                -18.6,
                -7.65
              ],
              [
                -68.9,
                30.1
              ]
            ],
            [
              [
                -18.6,
                -7.65
              ],
              [
                53,
                -53
              ],
              [
                69.2,
                -27.7
              ],
              [
                74.95,
                0
              ],
              [
                67.9,
                28.8
              ],
              [
                53,
                53.05
              ],
              [
                30.3,
                67.25
              ],
              [
                -0.05,
                75
              ],
              [
                -27.65,
                68.1
              ],
              [
                -53.05,
                53.05
              ],
              [
                -68.9,
                30.1
              ]
            ]
          ]
        },
        {
          "name": "movePlat1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                65,
                -5
              ],
              [
                65,
                5
              ],
              [
                -65,
                5
              ],
              [
                -65,
                -5
              ]
            ]
          ]
        },
        {
          "name": "movePlat2",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                65,
                -5
              ],
              [
                65,
                5
              ],
              [
                -65,
                5
              ],
              [
                -65,
                -5
              ]
            ]
          ]
        },
        {
          "name": "skyLeft",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                0,
                191.25
              ],
              [
                10.25,
                191.25
              ],
              [
                10.25,
                236.25
              ],
              [
                0,
                245.5
              ]
            ],
            [
              [
                199.75,
                460
              ],
              [
                114.75,
                444.2
              ],
              [
                123.75,
                435.85
              ],
              [
                199.75,
                451
              ]
            ],
            [
              [
                114.75,
                444.2
              ],
              [
                114.75,
                245.5
              ],
              [
                123.75,
                345.25
              ],
              [
                123.75,
                435.85
              ]
            ],
            [
              [
                199.75,
                359
              ],
              [
                123.75,
                345.25
              ],
              [
                123.75,
                336.25
              ],
              [
                199.75,
                350
              ]
            ],
            [
              [
                123.75,
                345.25
              ],
              [
                114.75,
                245.5
              ],
              [
                123.75,
                336.25
              ]
            ],
            [
              [
                123.75,
                336.25
              ],
              [
                114.75,
                245.5
              ],
              [
                123.75,
                245.25
              ]
            ],
            [
              [
                114.75,
                245.5
              ],
              [
                0,
                245.5
              ],
              [
                10.25,
                236.25
              ],
              [
                123.75,
                236.25
              ],
              [
                123.75,
                245.25
              ]
            ],
            [
              [
                199.75,
                259
              ],
              [
                123.75,
                245.25
              ],
              [
                123.75,
                236.25
              ],
              [
                199.75,
                250
              ]
            ]
          ]
        },
        {
          "name": "skyRight",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                76,
                132
              ],
              [
                85,
                132
              ],
              [
                76,
                286.85
              ]
            ],
            [
              [
                0,
                300
              ],
              [
                76,
                286.85
              ],
              [
                76,
                295.85
              ],
              [
                0,
                309
              ]
            ],
            [
              [
                76,
                286.85
              ],
              [
                85,
                132
              ],
              [
                76,
                295.85
              ]
            ],
            [
              [
                76,
                295.85
              ],
              [
                85,
                132
              ],
              [
                85,
                394.8
              ],
              [
                76,
                386.85
              ]
            ],
            [
              [
                0,
                400
              ],
              [
                76,
                386.85
              ],
              [
                85,
                394.8
              ],
              [
                0,
                409
              ]
            ]
          ]
        },
        {
          "name": "greenBarier",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                10,
                -75
              ],
              [
                10,
                75
              ],
              [
                -10,
                75
              ],
              [
                -10,
                -75
              ]
            ]
          ]
        },
        {
          "name": "pereval",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -56,
                10
              ],
              [
                -56,
                -10
              ],
              [
                56,
                -10
              ],
              [
                56,
                10
              ]
            ]
          ]
        },
        {
          "name": "pereval2",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -56,
                10
              ],
              [
                -56,
                -10
              ],
              [
                56,
                -10
              ],
              [
                56,
                10
              ]
            ]
          ]
        },
        {
          "name": "killStar1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -15,
                0.2
              ],
              [
                -2.15,
                -2.05
              ],
              [
                -2.05,
                2.1
              ]
            ],
            [
              [
                -2.15,
                -2.05
              ],
              [
                -0.25,
                -15
              ],
              [
                2,
                -2.15
              ],
              [
                2.1,
                2
              ],
              [
                0.2,
                15
              ],
              [
                -2.05,
                2.1
              ]
            ],
            [
              [
                15,
                -0.25
              ],
              [
                2.1,
                2
              ],
              [
                2,
                -2.15
              ]
            ]
          ]
        },
        {
          "name": "killStar2",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -15,
                0.2
              ],
              [
                -2.15,
                -2.05
              ],
              [
                -2.05,
                2.1
              ]
            ],
            [
              [
                -2.15,
                -2.05
              ],
              [
                -0.25,
                -15
              ],
              [
                2,
                -2.15
              ],
              [
                2.1,
                2
              ],
              [
                0.2,
                15
              ],
              [
                -2.05,
                2.1
              ]
            ],
            [
              [
                15,
                -0.25
              ],
              [
                2.1,
                2
              ],
              [
                2,
                -2.15
              ]
            ]
          ]
        }
      ]
    },
    {
      "id": 14,
      "className": "Levels.Level_14",
      "symbolId": 536,
      "svgPath": "port/generated/levels/level_14/1.svg",
      "imagePath": "port/generated/levels_png/level_14/1.png",
      "foregroundSvgPath": null,
      "layout": {
        "imageWidth": 5564.9,
        "imageHeight": 2186.2,
        "imageOffsetX": -2184.6,
        "imageOffsetY": -860.7,
        "namedChildren": {
          "backGroundMC": {
            "x": -376.1,
            "y": -244.05,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "levelAim": {
            "x": 1807.75,
            "y": 456.1,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": -300.5,
            "y": 559.1,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "firstPlatform": {
            "x": -237.0,
            "y": 589.0,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "movePlatform1": {
            "x": -33.0,
            "y": 321.0,
            "width": 302.2,
            "height": 152.5,
            "rotation": 0.0
          },
          "catapultPlat": {
            "x": 277.45,
            "y": 591.95,
            "width": 574.15,
            "height": 397.85,
            "rotation": 0.0
          },
          "floor": {
            "x": 229.8,
            "y": 280.95,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "bluePlat": {
            "x": 535.8,
            "y": 276.95,
            "width": 330.55,
            "height": 164.5,
            "rotation": 0.0
          },
          "catapult": {
            "x": 506.0,
            "y": 520.45,
            "width": 197.7,
            "height": 156.1,
            "rotation": 0.0
          },
          "catapultOpora": {
            "x": 506.2,
            "y": 522.25,
            "width": 309.5,
            "height": 398.1,
            "rotation": 0.0
          },
          "checkPoint1": {
            "x": 1025.5,
            "y": 528.1,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPlat": {
            "x": 1022.0,
            "y": 558.0,
            "width": 583.35,
            "height": 534.0,
            "rotation": 0.0
          },
          "dropPlat": {
            "x": 1310.0,
            "y": 553.0,
            "width": 286.5,
            "height": 174.5,
            "rotation": 0.0
          },
          "killRollBall": {
            "x": 1670.8,
            "y": 472.35,
            "width": 51.0,
            "height": 51.05,
            "rotation": 0.0
          },
          "finishPlat": {
            "x": 1689.5,
            "y": 495.5,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "blueCheck": {
            "x": 444.5,
            "y": 530.0,
            "width": 11.0,
            "height": 11.0,
            "rotation": 0.0
          },
          "ball40": {
            "x": 166.6,
            "y": 532.8,
            "width": 388.0,
            "height": 359.8,
            "rotation": 0.0
          },
          "barier": {
            "x": 1101.15,
            "y": 497.35,
            "width": 21.5,
            "height": 51.0,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5595,
        "sourceHeight": 2217,
        "cropX": 8,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2201
      },
      "symbols": {},
      "bodies": [
        {
          "name": "firstPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                140,
                10
              ],
              [
                -110,
                10
              ],
              [
                -110,
                -10
              ],
              [
                140,
                -10
              ]
            ]
          ]
        },
        {
          "name": "movePlatform1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -60,
                -5.35
              ],
              [
                -52.1,
                -17.1
              ],
              [
                -52.1,
                -5
              ],
              [
                -60,
                5
              ]
            ],
            [
              [
                60,
                5
              ],
              [
                -60,
                5
              ],
              [
                -52.1,
                -5
              ],
              [
                60,
                -5
              ]
            ]
          ]
        },
        {
          "name": "catapultPlat",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                94.8,
                -44
              ],
              [
                247.5,
                -44
              ],
              [
                -16.1,
                -12.95
              ]
            ],
            [
              [
                -247.5,
                -12.95
              ],
              [
                -16.1,
                -12.95
              ],
              [
                -247.5,
                44
              ]
            ],
            [
              [
                -16.1,
                -12.95
              ],
              [
                247.5,
                -44
              ],
              [
                247.5,
                44
              ],
              [
                -247.5,
                44
              ]
            ]
          ]
        },
        {
          "name": "ball40",
          "shape": "Circle",
          "density": 2,
          "friction": 0.2,
          "restitution": 0.2,
          "data": [
            45
          ]
        },
        {
          "name": "catapultOpora",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -0.25,
                -4.75
              ],
              [
                18.25,
                24.75
              ],
              [
                -18.25,
                24.75
              ]
            ]
          ]
        },
        {
          "name": "catapult",
          "shape": "Polygon",
          "density": 0.5,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -72.05,
                -16.75
              ],
              [
                -71.3,
                -10.4
              ],
              [
                -77.25,
                -16.75
              ]
            ],
            [
              [
                -71.3,
                -10.4
              ],
              [
                -69.4,
                -5.75
              ],
              [
                -70.25,
                1
              ],
              [
                -74.25,
                -3.65
              ],
              [
                -76.55,
                -10.1
              ],
              [
                -77.25,
                -16.75
              ]
            ],
            [
              [
                -70.25,
                1
              ],
              [
                -69.4,
                -5.75
              ],
              [
                -65.15,
                -3
              ],
              [
                -65,
                3
              ]
            ],
            [
              [
                54.4,
                3
              ],
              [
                -65,
                3
              ],
              [
                -46.65,
                -3
              ],
              [
                54.4,
                -3
              ]
            ],
            [
              [
                -46.65,
                -3
              ],
              [
                -65,
                3
              ],
              [
                -53.8,
                -3
              ],
              [
                -44.1,
                -7.1
              ]
            ],
            [
              [
                -42.6,
                -11.9
              ],
              [
                -44.1,
                -7.1
              ],
              [
                -47.15,
                -13.55
              ],
              [
                -47.15,
                -17
              ],
              [
                -41.9,
                -17
              ]
            ],
            [
              [
                -47.15,
                -13.55
              ],
              [
                -44.1,
                -7.1
              ],
              [
                -48.15,
                -9.7
              ]
            ],
            [
              [
                -48.15,
                -9.7
              ],
              [
                -44.1,
                -7.1
              ],
              [
                -50.25,
                -5.75
              ]
            ],
            [
              [
                -50.25,
                -5.75
              ],
              [
                -44.1,
                -7.1
              ],
              [
                -53.8,
                -3
              ]
            ],
            [
              [
                -53.8,
                -3
              ],
              [
                -65,
                3
              ],
              [
                -60,
                -2.25
              ]
            ],
            [
              [
                -60,
                -2.25
              ],
              [
                -65,
                3
              ],
              [
                -65.15,
                -3
              ]
            ]
          ]
        },
        {
          "name": "floor",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -199.9,
                9
              ],
              [
                -199.9,
                -9
              ],
              [
                257.1,
                -9
              ],
              [
                257.1,
                9
              ]
            ]
          ]
        },
        {
          "name": "bluePlat",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -44.8,
                -5
              ],
              [
                39.05,
                -5
              ],
              [
                47.6,
                5
              ],
              [
                -44.8,
                5
              ]
            ],
            [
              [
                39.05,
                -5
              ],
              [
                39.05,
                -17.3
              ],
              [
                47.6,
                -4.9
              ],
              [
                47.6,
                5
              ]
            ]
          ]
        },
        {
          "name": "checkPlat",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                158,
                -10
              ],
              [
                158,
                10
              ],
              [
                -62,
                10
              ],
              [
                -62,
                -10
              ]
            ]
          ]
        },
        {
          "name": "dropPlat",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -62,
                5
              ],
              [
                -62,
                -5
              ],
              [
                62,
                -5
              ],
              [
                62,
                5
              ]
            ]
          ]
        },
        {
          "name": "finishPlat",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                79.9,
                -10
              ],
              [
                162.5,
                -10
              ],
              [
                162.5,
                83.5
              ],
              [
                17.9,
                27.1
              ]
            ],
            [
              [
                -135.25,
                27.1
              ],
              [
                17.9,
                27.1
              ],
              [
                162.5,
                83.5
              ],
              [
                -118.25,
                59.5
              ]
            ],
            [
              [
                -250.45,
                59.5
              ],
              [
                -118.25,
                59.5
              ],
              [
                162.5,
                83.5
              ],
              [
                -250.45,
                79.5
              ]
            ]
          ]
        },
        {
          "name": "killRollBall",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            50
          ]
        },
        {
          "name": "barier",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                0,
                0
              ],
              [
                20,
                0
              ],
              [
                20,
                50
              ],
              [
                0,
                50
              ]
            ]
          ]
        },
        {
          "name": "dropPlat",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -62,
                5
              ],
              [
                -62,
                -5
              ],
              [
                62,
                -5
              ],
              [
                62,
                5
              ]
            ]
          ]
        }
      ]
    },
    {
      "id": 15,
      "className": "Levels.Level_15",
      "symbolId": 474,
      "svgPath": "port/generated/levels/level_15/1.svg",
      "imagePath": "port/generated/levels_png/level_15/1.png",
      "foregroundSvgPath": null,
      "layout": {
        "imageWidth": 5564.9,
        "imageHeight": 2186.2,
        "imageOffsetX": -1808.5,
        "imageOffsetY": -616.65,
        "namedChildren": {
          "backGroundMC": {
            "x": 0.0,
            "y": 0.0,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "levelAim": {
            "x": 2274.9,
            "y": 406.7,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "skateWheel11": {
            "x": 142.65,
            "y": 173.8,
            "width": 6.1,
            "height": 6.1,
            "rotation": 0.0
          },
          "skateWheel12": {
            "x": 162.9,
            "y": 173.8,
            "width": 6.1,
            "height": 6.1,
            "rotation": 0.0
          },
          "skateBoard1": {
            "x": 154.25,
            "y": 173.4,
            "width": 36.8,
            "height": 32.75,
            "rotation": 0.0
          },
          "rampa2": {
            "x": 1351.7,
            "y": 360.5,
            "width": 2129.4,
            "height": 753.8,
            "rotation": 0.0
          },
          "shopLeftSide": {
            "x": 230.05,
            "y": 98.5,
            "width": 585.05,
            "height": 193.1,
            "rotation": 0.0
          },
          "shopRightSide": {
            "x": 246.55,
            "y": 55.7,
            "width": 585.05,
            "height": 193.1,
            "rotation": 0.0
          },
          "step1": {
            "x": -48.2,
            "y": 149.0,
            "width": 380.0,
            "height": 138.0,
            "rotation": 0.0
          },
          "step2": {
            "x": -48.2,
            "y": 100.5,
            "width": 380.0,
            "height": 138.0,
            "rotation": 0.0
          },
          "step3": {
            "x": -48.2,
            "y": 50.5,
            "width": 380.0,
            "height": 138.0,
            "rotation": 0.0
          },
          "redGate": {
            "x": 418.0,
            "y": 183.55,
            "width": 276.8,
            "height": 403.1,
            "rotation": 0.0
          },
          "redCheck": {
            "x": 384.85,
            "y": 60.4,
            "width": 11.0,
            "height": 11.0,
            "rotation": 0.0
          },
          "finishPlat": {
            "x": 2218.9,
            "y": 484.95,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "barier": {
            "x": 2359.05,
            "y": 387.35,
            "width": 21.5,
            "height": 51.0,
            "rotation": 0.0
          },
          "checkPoint2": {
            "x": 229.25,
            "y": -12.65,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": 551.25,
            "y": 170.3,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "movePlatform": {
            "x": -288.95,
            "y": 368.0,
            "width": 216.4,
            "height": 78.2,
            "rotation": 0.0
          },
          "underShop": {
            "x": 98.35,
            "y": 232.85,
            "width": 979.6,
            "height": 725.95,
            "rotation": 0.0
          },
          "killLine": {
            "x": 312.25,
            "y": 61.0,
            "width": 3.0,
            "height": 33.0,
            "rotation": 0.0
          },
          "luk": {
            "x": 467.95,
            "y": 187.65,
            "width": 41.0,
            "height": 5.0,
            "rotation": 0.0
          },
          "checkPoint1": {
            "x": -164.7,
            "y": 170.3,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "money": {
            "x": 39.3,
            "y": 162.95,
            "width": 32.6,
            "height": 44.6,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5595,
        "sourceHeight": 2217,
        "cropX": 8,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2201
      },
      "symbols": {},
      "bodies": [
        {
          "name": "rampa2",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -543.75,
                -135.5
              ],
              [
                -487.75,
                -116.5
              ],
              [
                -147.8,
                14.5
              ],
              [
                -24.8,
                89.05
              ],
              [
                -128.4,
                77.55
              ],
              [
                -659.1,
                -3.15
              ],
              [
                -866.95,
                -54.4
              ],
              [
                -866.95,
                -170
              ],
              [
                -766.65,
                -170
              ],
              [
                -726.65,
                -167.5
              ],
              [
                -630.7,
                -154.5
              ],
              [
                -588.65,
                -146.5
              ]
            ],
            [
              [
                -1606.85,
                -54.4
              ],
              [
                -866.95,
                -54.4
              ],
              [
                -659.1,
                -3.15
              ],
              [
                -1606.85,
                -3.15
              ]
            ],
            [
              [
                291.95,
                40.05
              ],
              [
                291.95,
                89.05
              ],
              [
                281.45,
                45.05
              ]
            ],
            [
              [
                281.45,
                45.05
              ],
              [
                291.95,
                89.05
              ],
              [
                267.95,
                49.55
              ]
            ],
            [
              [
                267.95,
                49.55
              ],
              [
                291.95,
                89.05
              ],
              [
                252,
                52.55
              ]
            ],
            [
              [
                291.95,
                89.05
              ],
              [
                -24.8,
                89.05
              ],
              [
                227.5,
                55.05
              ],
              [
                252,
                52.55
              ]
            ],
            [
              [
                227.5,
                55.05
              ],
              [
                -24.8,
                89.05
              ],
              [
                163.45,
                57.5
              ]
            ],
            [
              [
                163.45,
                57.5
              ],
              [
                -24.8,
                89.05
              ],
              [
                142.45,
                57.5
              ]
            ],
            [
              [
                142.45,
                57.5
              ],
              [
                -24.8,
                89.05
              ],
              [
                46.45,
                51.55
              ]
            ],
            [
              [
                46.45,
                51.55
              ],
              [
                -24.8,
                89.05
              ],
              [
                -13.55,
                44.55
              ]
            ],
            [
              [
                -13.55,
                44.55
              ],
              [
                -24.8,
                89.05
              ],
              [
                -75.8,
                33.5
              ],
              [
                -41.05,
                39.65
              ]
            ],
            [
              [
                -75.8,
                33.5
              ],
              [
                -24.8,
                89.05
              ],
              [
                -121.3,
                22.5
              ]
            ],
            [
              [
                -121.3,
                22.5
              ],
              [
                -24.8,
                89.05
              ],
              [
                -147.8,
                14.5
              ]
            ]
          ]
        },
        {
          "name": "shopLeftSide",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                81.95,
                -91.5
              ],
              [
                81.95,
                -53.5
              ],
              [
                -230.7,
                -53.5
              ],
              [
                -263,
                -91.5
              ]
            ],
            [
              [
                182.95,
                91.5
              ],
              [
                -263,
                91.5
              ],
              [
                -230.7,
                81.75
              ],
              [
                182.95,
                81.75
              ]
            ],
            [
              [
                -263,
                91.5
              ],
              [
                -263,
                -91.5
              ],
              [
                -230.7,
                -53.5
              ],
              [
                -230.7,
                81.75
              ]
            ]
          ]
        },
        {
          "name": "shopRightSide",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                105.35,
                -10.9
              ],
              [
                105.35,
                -48.7
              ],
              [
                175.45,
                -48.7
              ],
              [
                153.35,
                -10.9
              ]
            ],
            [
              [
                -175.5,
                20.95
              ],
              [
                153.35,
                20.95
              ],
              [
                175.45,
                48.7
              ],
              [
                -175.5,
                48.7
              ]
            ],
            [
              [
                153.35,
                20.95
              ],
              [
                153.35,
                -10.9
              ],
              [
                175.45,
                -48.7
              ],
              [
                175.45,
                48.7
              ]
            ]
          ]
        },
        {
          "name": "step1",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                14.75,
                -3.5
              ],
              [
                14.75,
                3.5
              ],
              [
                -14.75,
                3.5
              ],
              [
                -14.75,
                -3.5
              ]
            ]
          ]
        },
        {
          "name": "step2",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                14.75,
                -3.5
              ],
              [
                14.75,
                3.5
              ],
              [
                -14.75,
                3.5
              ],
              [
                -14.75,
                -3.5
              ]
            ]
          ]
        },
        {
          "name": "step3",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                14.75,
                -3.5
              ],
              [
                14.75,
                3.5
              ],
              [
                -14.75,
                3.5
              ],
              [
                -14.75,
                -3.5
              ]
            ]
          ]
        },
        {
          "name": "redGate",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -4,
                -77.65
              ],
              [
                4,
                -77.65
              ],
              [
                4,
                5.35
              ],
              [
                -4,
                5.35
              ]
            ]
          ]
        },
        {
          "name": "finishPlat",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -160,
                -87.5
              ],
              [
                -115,
                -61.5
              ],
              [
                -160,
                0
              ]
            ],
            [
              [
                -115,
                -61.5
              ],
              [
                -99,
                -56
              ],
              [
                -160,
                0
              ]
            ],
            [
              [
                160,
                0
              ],
              [
                -160,
                0
              ],
              [
                -62,
                -48
              ],
              [
                160,
                -48
              ]
            ],
            [
              [
                -62,
                -48
              ],
              [
                -160,
                0
              ],
              [
                -80.3,
                -50.5
              ]
            ],
            [
              [
                -80.3,
                -50.5
              ],
              [
                -160,
                0
              ],
              [
                -99,
                -56
              ]
            ]
          ]
        },
        {
          "name": "barier",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                0,
                0
              ],
              [
                20,
                0
              ],
              [
                20,
                50
              ],
              [
                0,
                50
              ]
            ]
          ]
        },
        {
          "name": "movePlatform",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                30,
                -21
              ],
              [
                30,
                -11
              ],
              [
                -30,
                -11
              ],
              [
                -30,
                -21
              ]
            ]
          ]
        },
        {
          "name": "underShop",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -353.55,
                42.3
              ],
              [
                -353.55,
                -42.3
              ],
              [
                353.6,
                -42.3
              ],
              [
                353.6,
                42.3
              ]
            ]
          ]
        },
        {
          "name": "luk",
          "shape": "Polygon",
          "density": 0.3333333333333333,
          "friction": 0.3333333333333333,
          "restitution": 0.2,
          "data": [
            [
              [
                -20,
                2
              ],
              [
                -20,
                -2
              ],
              [
                20,
                -2
              ],
              [
                20,
                2
              ]
            ]
          ]
        },
        {
          "name": "skateBoard1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -19.6,
                -31.95
              ],
              [
                -14.9,
                -31.95
              ],
              [
                -16.3,
                -30
              ],
              [
                -19.6,
                -30
              ]
            ],
            [
              [
                -14.9,
                -31.95
              ],
              [
                -7.05,
                -3.2
              ],
              [
                -11.7,
                0.3
              ],
              [
                -16.3,
                -30
              ]
            ],
            [
              [
                -7.05,
                -3.2
              ],
              [
                9.9,
                -3.2
              ],
              [
                14.55,
                0.3
              ],
              [
                -11.7,
                0.3
              ]
            ],
            [
              [
                9.9,
                -3.2
              ],
              [
                15.4,
                -12
              ],
              [
                16.7,
                -12
              ],
              [
                14.55,
                0.3
              ]
            ]
          ]
        },
        {
          "name": "skateWheel11",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            6
          ]
        },
        {
          "name": "skateWheel12",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            6
          ]
        },
        {
          "name": "redGate",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -4,
                -77.65
              ],
              [
                4,
                -77.65
              ],
              [
                4,
                5.35
              ],
              [
                -4,
                5.35
              ]
            ]
          ]
        }
      ]
    },
    {
      "id": 16,
      "className": "Levels.Level_16",
      "symbolId": 328,
      "svgPath": "port/generated/levels/level_16/1.svg",
      "imagePath": "port/generated/levels_png/level_16/1.png",
      "foregroundSvgPath": null,
      "layout": {
        "imageWidth": 5564.9,
        "imageHeight": 2186.2,
        "imageOffsetX": -1808.5,
        "imageOffsetY": -616.65,
        "namedChildren": {
          "backGroundMC": {
            "x": 0.0,
            "y": 0.0,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "levelAim": {
            "x": -398.85,
            "y": 738.6,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "firstPlat": {
            "x": -352.95,
            "y": 570.95,
            "width": 376.7,
            "height": 593.05,
            "rotation": 0.0
          },
          "plat1": {
            "x": 338.95,
            "y": 329.0,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "plat2": {
            "x": 45.95,
            "y": 329.0,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "movePlatform1": {
            "x": 457.0,
            "y": 324.0,
            "width": 300.6,
            "height": 182.7,
            "rotation": 0.0
          },
          "movePlatform2": {
            "x": 1279.0,
            "y": 125.0,
            "width": 300.6,
            "height": 182.7,
            "rotation": 0.0
          },
          "dangerPlato": {
            "x": 1625.9,
            "y": 130.0,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "killRollBall1": {
            "x": 1784.25,
            "y": 70.35,
            "width": 51.0,
            "height": 51.05,
            "rotation": 0.0
          },
          "bluePlato": {
            "x": 2317.9,
            "y": 131.0,
            "width": 502.95,
            "height": 300.5,
            "rotation": 0.0
          },
          "jumpPlatform1": {
            "x": 860.35,
            "y": 319.3,
            "width": 428.1,
            "height": 309.15,
            "rotation": 0.0
          },
          "blueCheck1": {
            "x": 2187.2,
            "y": 105.35,
            "width": 11.0,
            "height": 11.0,
            "rotation": 0.0
          },
          "blueCheck2": {
            "x": 2326.2,
            "y": 105.35,
            "width": 11.0,
            "height": 11.0,
            "rotation": 0.0
          },
          "blueCheck3": {
            "x": 2453.2,
            "y": 105.35,
            "width": 11.0,
            "height": 11.0,
            "rotation": 0.0
          },
          "killRollBall2": {
            "x": 2439.2,
            "y": 70.35,
            "width": 51.0,
            "height": 51.05,
            "rotation": 0.0
          },
          "dropPlatform": {
            "x": 1969.2,
            "y": 125.35,
            "width": 286.5,
            "height": 174.5,
            "rotation": 0.0
          },
          "axe1": {
            "x": 2753.45,
            "y": -29.35,
            "width": 67.8,
            "height": 176.35,
            "rotation": -72.0310076566178
          },
          "finishPlato": {
            "x": 2936.9,
            "y": 99.0,
            "width": 765.4,
            "height": 300.5,
            "rotation": 0.0
          },
          "wrongWay": {
            "x": 3202.95,
            "y": 26.8,
            "width": 54.45,
            "height": 64.1,
            "rotation": 5.522387256321098
          },
          "checkPoint0": {
            "x": -341.55,
            "y": 299.4,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint1": {
            "x": 1449.35,
            "y": 101.45,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "checkPoint2": {
            "x": 2138.3,
            "y": 101.45,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "strelka": {
            "x": -122.6,
            "y": 326.5,
            "width": 20.1,
            "height": 29.0,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5595,
        "sourceHeight": 2217,
        "cropX": 8,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2201
      },
      "symbols": {},
      "bodies": [
        {
          "name": "firstPlat",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                218.95,
                252
              ],
              [
                -95,
                252
              ],
              [
                218.95,
                220.05
              ]
            ],
            [
              [
                218.95,
                220.05
              ],
              [
                -95,
                252
              ],
              [
                -69,
                197.05
              ],
              [
                245.95,
                197.05
              ],
              [
                245.95,
                207.05
              ]
            ],
            [
              [
                -95,
                252
              ],
              [
                -95,
                -251.95
              ],
              [
                -69,
                124
              ],
              [
                -69,
                197.05
              ]
            ],
            [
              [
                -95,
                -251.95
              ],
              [
                217.95,
                -251.95
              ],
              [
                89,
                151
              ],
              [
                -69,
                124
              ]
            ],
            [
              [
                89,
                151
              ],
              [
                217.95,
                -251.95
              ],
              [
                217.95,
                171.95
              ],
              [
                89,
                171.95
              ]
            ]
          ]
        },
        {
          "name": "plat2",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -131,
                10
              ],
              [
                -131,
                -10
              ],
              [
                131,
                -10
              ],
              [
                131,
                10
              ]
            ]
          ]
        },
        {
          "name": "plat1",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -55,
                -10
              ],
              [
                55,
                -10
              ],
              [
                55,
                10
              ],
              [
                -55,
                10
              ]
            ]
          ]
        },
        {
          "name": "movePlatform1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -40,
                5
              ],
              [
                -40,
                -5
              ],
              [
                40,
                -5
              ],
              [
                40,
                5
              ]
            ]
          ]
        },
        {
          "name": "movePlatform2",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -40,
                5
              ],
              [
                -40,
                -5
              ],
              [
                40,
                -5
              ],
              [
                40,
                5
              ]
            ]
          ]
        },
        {
          "name": "jumpPlatform1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "dangerPlato",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -210,
                10
              ],
              [
                -210,
                -10
              ],
              [
                210,
                -10
              ],
              [
                210,
                10
              ]
            ]
          ]
        },
        {
          "name": "bluePlato",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -210,
                10
              ],
              [
                -210,
                -10
              ],
              [
                210,
                -10
              ],
              [
                210,
                10
              ]
            ]
          ]
        },
        {
          "name": "dropPlatform",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -62,
                -5
              ],
              [
                62,
                -5
              ],
              [
                62,
                5
              ],
              [
                -62,
                5
              ]
            ]
          ]
        },
        {
          "name": "killRollBall1",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            50
          ]
        },
        {
          "name": "killRollBall2",
          "shape": "Circle",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            50
          ]
        },
        {
          "name": "finishPlato",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                74.7,
                -41.95
              ],
              [
                316,
                -41.95
              ],
              [
                316,
                42
              ],
              [
                -13.75,
                22
              ]
            ],
            [
              [
                -316,
                22
              ],
              [
                -13.75,
                22
              ],
              [
                316,
                42
              ],
              [
                -316,
                42
              ]
            ]
          ]
        },
        {
          "name": "axe1",
          "shape": "Polygon",
          "density": 2.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                25.5,
                -1.5
              ],
              [
                40.5,
                -1.5
              ],
              [
                40.5,
                113.5
              ],
              [
                25.5,
                113.5
              ]
            ],
            [
              [
                0.5,
                116.5
              ],
              [
                25.5,
                113.5
              ],
              [
                40.5,
                113.5
              ],
              [
                67.5,
                116.5
              ],
              [
                67.5,
                175.5
              ],
              [
                0.5,
                175.5
              ]
            ]
          ]
        },
        {
          "name": "dropPlatform",
          "shape": "Polygon",
          "density": 3.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -62,
                -5
              ],
              [
                62,
                -5
              ],
              [
                62,
                5
              ],
              [
                -62,
                5
              ]
            ]
          ]
        }
      ]
    },
    {
      "id": 17,
      "className": "Levels.Level_17",
      "symbolId": 493,
      "svgPath": "port/generated/levels/level_17/1.svg",
      "imagePath": "port/generated/levels_png/level_17/1.png",
      "foregroundSvgPath": null,
      "layout": {
        "imageWidth": 5564.9,
        "imageHeight": 2186.2,
        "imageOffsetX": -1808.5,
        "imageOffsetY": -616.65,
        "namedChildren": {
          "backGroundMC": {
            "x": 0.0,
            "y": 0.0,
            "width": 5564.9,
            "height": 2186.2,
            "rotation": 0.0
          },
          "levelAim": {
            "x": 2225.55,
            "y": 370.7,
            "width": 25.2,
            "height": 46.5,
            "rotation": 0.0
          },
          "checkPoint0": {
            "x": -263.6,
            "y": 404.3,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "kingCrown1": {
            "x": 39.55,
            "y": 460.55,
            "width": 1124.3,
            "height": 602.25,
            "rotation": 0.0
          },
          "kingCrown2": {
            "x": 1509.55,
            "y": 460.55,
            "width": 1124.3,
            "height": 642.0,
            "rotation": 0.0
          },
          "jumpPlatform1": {
            "x": 112.35,
            "y": 423.85,
            "width": 428.1,
            "height": 309.15,
            "rotation": 0.0
          },
          "killStarPart": {
            "x": 275.85,
            "y": 243.5,
            "width": 37.95,
            "height": 39.05,
            "rotation": 0.0
          },
          "star": {
            "x": 542.85,
            "y": 450.8,
            "width": 121.3,
            "height": 120.25,
            "rotation": 0.0
          },
          "checkPoint1": {
            "x": 1274.3,
            "y": 380.3,
            "width": 10.8,
            "height": 21.1,
            "rotation": 0.0
          },
          "movePlatform1": {
            "x": 903.25,
            "y": 438.35,
            "width": 300.6,
            "height": 182.7,
            "rotation": 0.0
          },
          "movePlatform2": {
            "x": 1617.25,
            "y": 430.0,
            "width": 300.6,
            "height": 182.7,
            "rotation": 0.0
          },
          "kingLogo": {
            "x": 2268.2,
            "y": 261.0,
            "width": 0.0,
            "height": 0.0,
            "rotation": 0.0
          }
        }
      },
      "pngLayout": {
        "sourceWidth": 5595,
        "sourceHeight": 2217,
        "cropX": 8,
        "cropY": 8,
        "cropWidth": 5578,
        "cropHeight": 2201
      },
      "symbols": {},
      "bodies": [
        {
          "name": "kingCrown1",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                686.25,
                10.5
              ],
              [
                706.05,
                -27.4
              ],
              [
                717.65,
                5.45
              ]
            ],
            [
              [
                508.8,
                -8.85
              ],
              [
                505.8,
                112.95
              ],
              [
                455.85,
                100.95
              ],
              [
                500.65,
                -10.1
              ]
            ],
            [
              [
                505.8,
                112.95
              ],
              [
                509.8,
                180.9
              ],
              [
                429.85,
                146.9
              ],
              [
                455.85,
                100.95
              ]
            ],
            [
              [
                509.8,
                180.9
              ],
              [
                533.8,
                212.9
              ],
              [
                387.85,
                186.9
              ],
              [
                429.85,
                146.9
              ]
            ],
            [
              [
                387.85,
                186.9
              ],
              [
                533.8,
                212.9
              ],
              [
                -58,
                224.9
              ],
              [
                -33.3,
                205.4
              ],
              [
                113.95,
                190.9
              ],
              [
                143.95,
                188.9
              ],
              [
                343.85,
                186.9
              ]
            ],
            [
              [
                273.5,
                -120.6
              ],
              [
                248.6,
                -134.35
              ],
              [
                217,
                -197.85
              ],
              [
                253.95,
                -198.4
              ],
              [
                266.4,
                -162.65
              ]
            ],
            [
              [
                296.45,
                -192.45
              ],
              [
                266.4,
                -162.65
              ],
              [
                253.95,
                -198.4
              ]
            ],
            [
              [
                248.6,
                -134.35
              ],
              [
                271.9,
                78.95
              ],
              [
                222.25,
                -133.95
              ],
              [
                217,
                -197.85
              ]
            ],
            [
              [
                175.1,
                -192.05
              ],
              [
                217,
                -197.85
              ],
              [
                205.15,
                -162.9
              ]
            ],
            [
              [
                205.15,
                -162.9
              ],
              [
                217,
                -197.85
              ],
              [
                222.25,
                -133.95
              ],
              [
                197.8,
                -120.65
              ]
            ],
            [
              [
                222.25,
                -133.95
              ],
              [
                271.9,
                78.95
              ],
              [
                203.9,
                86.95
              ]
            ],
            [
              [
                271.9,
                78.95
              ],
              [
                287.9,
                128.95
              ],
              [
                203.9,
                86.95
              ]
            ],
            [
              [
                287.9,
                128.95
              ],
              [
                309.9,
                166.9
              ],
              [
                171.95,
                158.9
              ],
              [
                203.9,
                86.95
              ]
            ],
            [
              [
                309.9,
                166.9
              ],
              [
                343.85,
                186.9
              ],
              [
                143.95,
                188.9
              ],
              [
                171.95,
                158.9
              ]
            ],
            [
              [
                18.3,
                39.4
              ],
              [
                -10.15,
                29.25
              ],
              [
                5.75,
                -1.4
              ]
            ],
            [
              [
                -10.15,
                29.25
              ],
              [
                -10.3,
                29.3
              ],
              [
                -47.9,
                -29.8
              ],
              [
                -34.85,
                -69.95
              ],
              [
                -11.3,
                -35.2
              ],
              [
                5.75,
                -1.4
              ]
            ],
            [
              [
                31.65,
                -34.9
              ],
              [
                5.75,
                -1.4
              ],
              [
                -11.3,
                -35.2
              ]
            ],
            [
              [
                -10.3,
                29.3
              ],
              [
                34,
                120.95
              ],
              [
                -33.3,
                32.95
              ],
              [
                -47.9,
                -29.8
              ]
            ],
            [
              [
                -88.65,
                -18.6
              ],
              [
                -47.9,
                -29.8
              ],
              [
                -55.05,
                6.4
              ]
            ],
            [
              [
                -55.05,
                6.4
              ],
              [
                -47.9,
                -29.8
              ],
              [
                -33.35,
                32.9
              ],
              [
                -56.75,
                49.3
              ]
            ],
            [
              [
                -33.35,
                32.9
              ],
              [
                -47.9,
                -29.8
              ],
              [
                -33.3,
                32.95
              ]
            ],
            [
              [
                -33.3,
                32.95
              ],
              [
                34,
                120.95
              ],
              [
                -33.3,
                205.4
              ]
            ],
            [
              [
                34,
                120.95
              ],
              [
                81.95,
                176.9
              ],
              [
                -33.3,
                205.4
              ]
            ],
            [
              [
                81.95,
                176.9
              ],
              [
                113.95,
                190.9
              ],
              [
                -33.3,
                205.4
              ]
            ],
            [
              [
                533.8,
                212.9
              ],
              [
                571.8,
                212.9
              ],
              [
                629.75,
                402.85
              ],
              [
                -135.95,
                402.85
              ],
              [
                -58,
                224.9
              ]
            ],
            [
              [
                -205.45,
                10.5
              ],
              [
                -237.6,
                5.3
              ],
              [
                -225.25,
                -27.4
              ]
            ],
            [
              [
                -237.6,
                5.3
              ],
              [
                -238.15,
                5.7
              ],
              [
                -283.2,
                -45.5
              ],
              [
                -277.7,
                -87.35
              ],
              [
                -248.2,
                -57.5
              ],
              [
                -225.25,
                -27.4
              ]
            ],
            [
              [
                -205.9,
                -65.05
              ],
              [
                -225.25,
                -27.4
              ],
              [
                -248.2,
                -57.5
              ]
            ],
            [
              [
                -238.15,
                5.7
              ],
              [
                -108.55,
                188.9
              ],
              [
                -257.95,
                14.15
              ],
              [
                -283.2,
                -45.5
              ]
            ],
            [
              [
                -321.25,
                -27
              ],
              [
                -283.2,
                -45.5
              ],
              [
                -283.65,
                -8.6
              ]
            ],
            [
              [
                -283.65,
                -8.6
              ],
              [
                -283.2,
                -45.5
              ],
              [
                -258,
                14.1
              ],
              [
                -277.45,
                33.95
              ]
            ],
            [
              [
                -258,
                14.1
              ],
              [
                -283.2,
                -45.5
              ],
              [
                -257.95,
                14.15
              ]
            ],
            [
              [
                -257.95,
                14.15
              ],
              [
                -108.55,
                188.9
              ],
              [
                -135.95,
                402.85
              ]
            ],
            [
              [
                -108.55,
                188.9
              ],
              [
                -83.95,
                216.9
              ],
              [
                -135.95,
                402.85
              ]
            ],
            [
              [
                -83.95,
                216.9
              ],
              [
                -58,
                224.9
              ],
              [
                -135.95,
                402.85
              ]
            ],
            [
              [
                571.8,
                212.9
              ],
              [
                627.75,
                150.9
              ],
              [
                629.75,
                402.85
              ]
            ],
            [
              [
                627.75,
                150.9
              ],
              [
                717.65,
                5.45
              ],
              [
                736.95,
                13.45
              ],
              [
                629.75,
                402.85
              ]
            ],
            [
              [
                717.65,
                5.45
              ],
              [
                706.05,
                -27.4
              ],
              [
                736.95,
                13.45
              ]
            ],
            [
              [
                706.05,
                -27.4
              ],
              [
                686.7,
                -65.05
              ],
              [
                764.45,
                -8.6
              ],
              [
                758.25,
                33.95
              ],
              [
                736.95,
                13.45
              ]
            ],
            [
              [
                764.45,
                -8.6
              ],
              [
                686.7,
                -65.05
              ],
              [
                729,
                -57.5
              ],
              [
                764,
                -45.5
              ],
              [
                801.2,
                -27.4
              ],
              [
                801.05,
                -26.55
              ]
            ],
            [
              [
                758.5,
                -87.35
              ],
              [
                764,
                -45.5
              ],
              [
                729,
                -57.5
              ]
            ]
          ]
        },
        {
          "name": "kingCrown2",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                686.25,
                10.5
              ],
              [
                706.05,
                -27.4
              ],
              [
                717.65,
                5.45
              ]
            ],
            [
              [
                516.8,
                68.9
              ],
              [
                505.8,
                112.95
              ],
              [
                468.85,
                119.45
              ]
            ],
            [
              [
                505.8,
                112.95
              ],
              [
                509.8,
                180.9
              ],
              [
                448.35,
                138.9
              ],
              [
                468.85,
                119.45
              ]
            ],
            [
              [
                509.8,
                180.9
              ],
              [
                533.8,
                212.9
              ],
              [
                386.35,
                173.9
              ],
              [
                448.35,
                138.9
              ]
            ],
            [
              [
                386.35,
                173.9
              ],
              [
                533.8,
                212.9
              ],
              [
                373,
                176.4
              ]
            ],
            [
              [
                373,
                176.4
              ],
              [
                533.8,
                212.9
              ],
              [
                352.35,
                176.4
              ]
            ],
            [
              [
                352.35,
                176.4
              ],
              [
                533.8,
                212.9
              ],
              [
                143.95,
                188.9
              ],
              [
                171.95,
                158.9
              ],
              [
                337.1,
                174.2
              ]
            ],
            [
              [
                273.5,
                -120.6
              ],
              [
                248.6,
                -134.35
              ],
              [
                235.5,
                -238.15
              ],
              [
                253.95,
                -198.4
              ],
              [
                266.4,
                -162.65
              ]
            ],
            [
              [
                296.45,
                -192.45
              ],
              [
                266.4,
                -162.65
              ],
              [
                253.95,
                -198.4
              ]
            ],
            [
              [
                248.6,
                -134.35
              ],
              [
                273.4,
                78.95
              ],
              [
                222.25,
                -133.95
              ],
              [
                217,
                -197.85
              ],
              [
                235.5,
                -238.15
              ]
            ],
            [
              [
                175.1,
                -192.05
              ],
              [
                217,
                -197.85
              ],
              [
                205.15,
                -162.9
              ]
            ],
            [
              [
                205.15,
                -162.9
              ],
              [
                217,
                -197.85
              ],
              [
                222.25,
                -133.95
              ],
              [
                197.8,
                -120.65
              ]
            ],
            [
              [
                222.25,
                -133.95
              ],
              [
                273.4,
                78.95
              ],
              [
                203.9,
                86.95
              ]
            ],
            [
              [
                273.4,
                78.95
              ],
              [
                290.9,
                127.95
              ],
              [
                203.9,
                86.95
              ]
            ],
            [
              [
                290.9,
                127.95
              ],
              [
                305.1,
                152.05
              ],
              [
                203.9,
                86.95
              ]
            ],
            [
              [
                305.1,
                152.05
              ],
              [
                321.9,
                167.4
              ],
              [
                171.95,
                158.9
              ],
              [
                203.9,
                86.95
              ]
            ],
            [
              [
                321.9,
                167.4
              ],
              [
                337.1,
                174.2
              ],
              [
                171.95,
                158.9
              ]
            ],
            [
              [
                143.95,
                188.9
              ],
              [
                533.8,
                212.9
              ],
              [
                -58,
                224.9
              ],
              [
                -33.3,
                205.4
              ],
              [
                113.95,
                190.9
              ]
            ],
            [
              [
                18.3,
                39.4
              ],
              [
                -10.15,
                29.25
              ],
              [
                5.75,
                -1.4
              ]
            ],
            [
              [
                -10.15,
                29.25
              ],
              [
                -10.3,
                29.3
              ],
              [
                -47.9,
                -29.8
              ],
              [
                -34.85,
                -69.95
              ],
              [
                -11.3,
                -35.2
              ],
              [
                5.75,
                -1.4
              ]
            ],
            [
              [
                31.65,
                -34.9
              ],
              [
                5.75,
                -1.4
              ],
              [
                -11.3,
                -35.2
              ]
            ],
            [
              [
                -10.3,
                29.3
              ],
              [
                34,
                120.95
              ],
              [
                -33.3,
                32.95
              ],
              [
                -47.9,
                -29.8
              ]
            ],
            [
              [
                -88.65,
                -18.6
              ],
              [
                -47.9,
                -29.8
              ],
              [
                -55.05,
                6.4
              ]
            ],
            [
              [
                -55.05,
                6.4
              ],
              [
                -47.9,
                -29.8
              ],
              [
                -33.35,
                32.9
              ],
              [
                -56.75,
                49.3
              ]
            ],
            [
              [
                -33.35,
                32.9
              ],
              [
                -47.9,
                -29.8
              ],
              [
                -33.3,
                32.95
              ]
            ],
            [
              [
                -33.3,
                32.95
              ],
              [
                34,
                120.95
              ],
              [
                -33.3,
                205.4
              ]
            ],
            [
              [
                34,
                120.95
              ],
              [
                81.95,
                176.9
              ],
              [
                -33.3,
                205.4
              ]
            ],
            [
              [
                81.95,
                176.9
              ],
              [
                113.95,
                190.9
              ],
              [
                -33.3,
                205.4
              ]
            ],
            [
              [
                533.8,
                212.9
              ],
              [
                571.8,
                212.9
              ],
              [
                629.75,
                402.85
              ],
              [
                -135.95,
                402.85
              ],
              [
                -58,
                224.9
              ]
            ],
            [
              [
                -205.45,
                10.5
              ],
              [
                -237.6,
                5.3
              ],
              [
                -225.25,
                -27.4
              ]
            ],
            [
              [
                -237.6,
                5.3
              ],
              [
                -238.15,
                5.7
              ],
              [
                -283.2,
                -45.5
              ],
              [
                -277.7,
                -87.35
              ],
              [
                -248.2,
                -57.5
              ],
              [
                -225.25,
                -27.4
              ]
            ],
            [
              [
                -205.9,
                -65.05
              ],
              [
                -225.25,
                -27.4
              ],
              [
                -248.2,
                -57.5
              ]
            ],
            [
              [
                -238.15,
                5.7
              ],
              [
                -108.55,
                188.9
              ],
              [
                -257.95,
                14.15
              ],
              [
                -283.2,
                -45.5
              ]
            ],
            [
              [
                -321.25,
                -27
              ],
              [
                -283.2,
                -45.5
              ],
              [
                -283.65,
                -8.6
              ]
            ],
            [
              [
                -283.65,
                -8.6
              ],
              [
                -283.2,
                -45.5
              ],
              [
                -258,
                14.1
              ],
              [
                -277.45,
                33.95
              ]
            ],
            [
              [
                -258,
                14.1
              ],
              [
                -283.2,
                -45.5
              ],
              [
                -257.95,
                14.15
              ]
            ],
            [
              [
                -257.95,
                14.15
              ],
              [
                -108.55,
                188.9
              ],
              [
                -135.95,
                402.85
              ]
            ],
            [
              [
                -108.55,
                188.9
              ],
              [
                -83.95,
                216.9
              ],
              [
                -135.95,
                402.85
              ]
            ],
            [
              [
                -83.95,
                216.9
              ],
              [
                -58,
                224.9
              ],
              [
                -135.95,
                402.85
              ]
            ],
            [
              [
                571.8,
                212.9
              ],
              [
                627.75,
                150.9
              ],
              [
                629.75,
                402.85
              ]
            ],
            [
              [
                627.75,
                150.9
              ],
              [
                717.65,
                5.45
              ],
              [
                736.95,
                13.45
              ],
              [
                629.75,
                402.85
              ]
            ],
            [
              [
                717.65,
                5.45
              ],
              [
                706.05,
                -27.4
              ],
              [
                736.95,
                13.45
              ]
            ],
            [
              [
                706.05,
                -27.4
              ],
              [
                686.7,
                -65.05
              ],
              [
                764.45,
                -8.6
              ],
              [
                758.25,
                33.95
              ],
              [
                736.95,
                13.45
              ]
            ],
            [
              [
                764.45,
                -8.6
              ],
              [
                686.7,
                -65.05
              ],
              [
                729,
                -57.5
              ],
              [
                764,
                -45.5
              ],
              [
                801.2,
                -27.4
              ],
              [
                801.05,
                -26.55
              ]
            ],
            [
              [
                758.5,
                -87.35
              ],
              [
                764,
                -45.5
              ],
              [
                729,
                -57.5
              ]
            ]
          ]
        },
        {
          "name": "jumpPlatform1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                100,
                0
              ],
              [
                100,
                20
              ],
              [
                0,
                20
              ],
              [
                0,
                0
              ]
            ]
          ]
        },
        {
          "name": "killStarPart",
          "shape": "Polygon",
          "density": 0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -0.3,
                -19
              ],
              [
                18.5,
                18.5
              ],
              [
                -18.45,
                19.05
              ]
            ]
          ]
        },
        {
          "name": "star",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                6.35,
                -59.65
              ],
              [
                19.4,
                -19.5
              ],
              [
                -17.2,
                -24.9
              ]
            ],
            [
              [
                -17.2,
                -24.9
              ],
              [
                19.4,
                -19.5
              ],
              [
                -34.25,
                8.9
              ],
              [
                -60.15,
                -24.6
              ]
            ],
            [
              [
                -34.25,
                8.9
              ],
              [
                19.4,
                -19.5
              ],
              [
                -4.55,
                34.9
              ],
              [
                -46.8,
                49.7
              ]
            ],
            [
              [
                -4.55,
                34.9
              ],
              [
                19.4,
                -19.5
              ],
              [
                26.55,
                16.7
              ],
              [
                28.25,
                59.6
              ],
              [
                4.3,
                42.2
              ]
            ],
            [
              [
                60.15,
                -8.3
              ],
              [
                26.55,
                16.7
              ],
              [
                19.4,
                -19.5
              ]
            ]
          ]
        },
        {
          "name": "movePlatform1",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -40,
                5
              ],
              [
                -40,
                -5
              ],
              [
                40,
                -5
              ],
              [
                40,
                5
              ]
            ]
          ]
        },
        {
          "name": "movePlatform2",
          "shape": "Polygon",
          "density": 1.0,
          "friction": 1.0,
          "restitution": 0.2,
          "data": [
            [
              [
                -40,
                5
              ],
              [
                -40,
                -5
              ],
              [
                40,
                -5
              ],
              [
                40,
                5
              ]
            ]
          ]
        }
      ]
    }
  ]
}
